import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { toast, ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  getExhibitorDetails_action,
  updateExhibitorDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/exhibitor_details_action/exhibitor_details_action";
import { insertUserRegistration_action, getExhibitionSSRCountryMappingData_action } from '../../../../../actions/user_registration_action';
import {
  primaryChapterListActionId,
  toastError,
  toastSuccess,
  internationalAreaSlabActionId,
  countryActionId,
  stallTypeActionId, fullStallAreaActionId,
  stallSizeActionId, lengthActionId, breadthActionId,
  openSideListActionId,
  BASE_URL,
} from "../../../../../utils/constants";
import {
  getDetails_spaceBooking_action,
  edit_spaceBoking_action,
  updateSpacebookingEstimate_action,
} from "../../../../../actions/exhibitor_module_actions/space_booking_action/spaceBooking_action";
import Modal from "react-modal";
import { data } from "jquery";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import { fill_action } from "../../../../../actions/fillCombo_action";
import { getDoubleStoreySSI_action } from "../../../../../actions/primary_chapter_action";
import moment from "moment";
import Resizer from "react-image-file-resizer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

class ExhibitorDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isOpen: false,
      exhibitionID: "",
      exhRegistrationID: "",
      exbTableErr: "",
      compareObjArr: [],
      stallArea: "",
      subChapters: [],
      level2: "",
      level3: "",
      level4: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      guideLines: [],
      isShowMachineryGuidelines: false,
      guidelinesAddress: "",
      Remark: "",
      StatusID: "",
      regCompany: "",
      fasciaName: "",
      otherPersonInchFirst: "",
      personInchFirst: "",
      preFixPersonInch: "Mr",
      isOtherPreFixPersonInch: false,
      personInchLast: "",
      regDesignation: "",
      regCountry: "",
      primaryChapterName: "",
      stallTypeIdList: [],
      stallArea: "",
      stallAreaList: [],
      area: "",
      isChargesforOpenSides: false,
      openSideList: [],
      openSlides: "",
      stallTypeId: "",

      InternationalArea: "",
      InternationalAreaErr: "",
      exhibitDetailsTableErr: "",
      countryId: "",
      countryList: [],
      stallTypeIdList: [],
      openSideList: [],
      stallAreaList: [],
      stallArea: "",
      stallAreaName: "",
      stallArea: "",
      area: "",
      openSlides: "",
      stallTypeId: "",
      isDoubleStoreyExhibition: false,
      isDoubleStorey: false,
      doubleStoreyArea: "",
      DueDate: "",
      internationalAreaSlabList: [],
      oldInternationalArea: "",
      oldsubChapters: [],
      newestimateDetails: [],
      estimatePop: false,
      isUpdatePerm: false,
      ExhibitDetailsNote: [],
      minAreafor4OpenSide: 300,
      fileName: "",
      filePath: "",
      fileType: "",
      CompanyInformation: "",
      CompanyInformationErr: "",
      textEntriesErr: "",
      brochureErr: "",
      RemarkErr: "",
      isReadOnly: true,
      //
      inputText: "",
      textEntries: [],
      fileIsFromBackend: false,
      selectedFile: "",
      Is_View:
        this.props.location.state != null && this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      enableArea: false,
      enableScheme: false,
      isOpen4: false,
      expectedArea: '',
      intAreaRulesPop: false,
      isOpen2: false,
      expectedAreaId: '',
      areaValidationPopFlag: 1,
      oldstallArea: '',
      oldarea: '',
      oldstallTypeId: '',
      oldInternationalArea: '',
      SSRCountryList: [],
      isShowInternationalArea: false,
      isOpen5: false,
      referenceStallAreaArr: [],
      isAllBro: false,
    };

    this.getExhibitorDetails = this.getExhibitorDetails.bind(this);
    this.updateExhibitorDetails = this.updateExhibitorDetails.bind(this);
    this.onEnterProductName = this.onEnterProductName.bind(this);
    this.onMachineDetailsChange = this.onMachineDetailsChange.bind(this);
    this.onEnterHSNCode = this.onEnterHSNCode.bind(this);
    this.onLengthChange = this.onLengthChange.bind(this);
    this.onBreadthChange = this.onBreadthChange.bind(this);
    this.onHeightChange = this.onHeightChange.bind(this);
    this.onFloorCapacityChange = this.onFloorCapacityChange.bind(this);
    this.onMachineWeightChange = this.onMachineWeightChange.bind(this);
    this.onManufacturerNameChange = this.onManufacturerNameChange.bind(this);
    this.maxLengthCheck = this.maxLengthCheck.bind(this);
    this.onAddClick = this.onAddClick.bind(this);
    this.onCheckLevel2 = this.onCheckLevel2.bind(this);
    this.record = this.record.bind(this);
    this.onSelectLevel4 = this.onSelectLevel4.bind(this);
    this.onCheckLevel3 = this.onCheckLevel3.bind(this);
    this.recordFour = this.recordFour.bind(this);
    this.onMBclick = this.onMBclick.bind(this);
    console.log("hiii", props);
    this.handleConfirmation = this.handleConfirmation.bind(this)
    this.adjustIntAreaNew = this.adjustIntAreaNew.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.updateExhibitorDetails()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
    });
    this.getFillList(
      internationalAreaSlabActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    ).then(() => {
      setTimeout(() => {
        this.getExhibitorDetails();
        this.getDoubleStroeySSI();
        this.getExhibitionSSRCountryMappingData(sessionStorage.getItem('exhibitionCode'))
      }, 200);
    });
    // this.getFillList(primaryChapterListActionId, '', '', '', '', '');
  }

  getExhibitionSSRCountryMappingData(exhCode) {
    this.setState({ isLoading: true });
    return new Promise((resolve, reject) => {
      this.props
        .getExhibitionSSRCountryMappingData_action(exhCode)
        .then((data) => {
          if (data.error != 1 && data.data != null && data.data.length > 0) {
            // console.log(data.data, 'agent')
            // var chapterIDArr = data.data[0]["ChapterID"] != '' && data.data[0]["ChapterID"] != null ? data.data[0]["ChapterID"].split(',') : []
            // console.log(chapterIDArr, 'chapterIDArr')
            // for (var i = 0; i < chapterIDArr.length; i++) {
            //     chapterIDArr[i] = chapterIDArr[i].trim()
            //     chapterIDArr[i] = parseInt(chapterIDArr[i])
            // }
            this.setState({ SSRCountryList: data.data });
            // resolve(true)
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    })
  }

  handleCancel() {
    window.history.back();
  }

  openBrochure = () => {
    if (!this.state.filePath) return;
    console.log("FILE PATH VALUE:", this.state.filePath);

    if (this.state.fileIsFromBackend) {
      // OPEN FROM YOUR SERVER
      const fullUrl = BASE_URL.split("/api")[0] + this.state.filePath;
      window.open(fullUrl, "_blank");
    } else {
      const [meta, base64Data] = this.state.filePath.split(",");
      const mimeType = meta.match(/data:(.*);base64/)[1]; // <-- detect correct type

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType }); // <-- use correct type
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    }
  };

  // updateExhibitorDetails() {
  //   const { subChapters, exbTableErr, Remark, stallAreaName, area, InternationalArea } = this.state;
  //   // Preparing SubChapter List For Udt
  //   var list = [];
  //   subChapters.map((data) => {
  //     var data = {
  //       ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID")),
  //       ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
  //       ChapterID: data.ChapterID,
  //       ChapterName: data.ChapterName,
  //       HSNCode: data.HSNCode,
  //       MachineDetails: data.MachineDetails,
  //       Length: data.Length,
  //       Breadth: data.Breadth,
  //       Height: data.Height,
  //       FloorCapacity: data.FloorCapacity,
  //       MachineWeight: data.MachineWeight,
  //       ManufacturerName: data.ManufacturerName,
  //       ManufacturingCountry: data.ManufacturingCountry,
  //       isMachine: data.isMachine,
  //       isBrochure: data.isBrochure,
  //     };
  //     list.push(data);
  //   });
  //   console.log("Ramark--", Remark);
  //   var iserror = false;
  //   if (subChapters.length == 0) {
  //     console.log("exhibitDetailsList", subChapters);
  //     this.setState({
  //       exbTableErr: "Please select atleast one chapter",
  //     });
  //     iserror = true;
  //   }
  //   var lengthErr = "";
  //   if (exbTableErr != "") {
  //     console.log("exhibitDetailsList", subChapters);
  //     // this.setState({
  //     //     exhibitDetailsTableErr: 'Please select atleast one chapter'
  //     // })
  //     iserror = true;
  //     lengthErr = exbTableErr;
  //   }
  //   const isAllMB = subChapters.every((item) =>
  //     item.isMachine != undefined && item.isBrochure != undefined
  //       ? item.isMachine || item.isBrochure
  //       : false
  //   );
  //   subChapters.every((item) =>
  //     console.log(
  //       item.isMachine != undefined && item.isBrochure != undefined,
  //       (item.isMachine, item.isBrochure)
  //     )
  //   );

  //   console.log(isAllMB);
  //   var DueDateValidation = false;
  //   if (this.state.DueDate != "") {
  //     if (new Date(this.state.DueDate) < new Date()) {
  //       DueDateValidation = true;
  //     }
  //   }
  //   var totalEnterSpace = 0;
  //   for (var i = 0; i < subChapters.length; i++) {
  //     if (
  //       stallAreaName != null &&
  //       stallAreaName != "" &&
  //       subChapters[i].Length != null &&
  //       subChapters[i].Length != "" &&
  //       subChapters[i].Length != 0 &&
  //       subChapters[i].Breadth != null &&
  //       subChapters[i].Breadth != "" &&
  //       subChapters[i].Breadth != 0
  //     ) {
  //       var currentArea = parseFloat(subChapters[i].Length) * parseFloat(subChapters[i].Breadth);
  //       totalEnterSpace = totalEnterSpace + currentArea;
  //     }
  //     if (
  //       subChapters[i].Length == "" ||
  //       subChapters[i].Length == 0 ||
  //       subChapters[i].Length == null
  //     ) {
  //       if (
  //         DueDateValidation &&
  //         !(
  //           subChapters[i].isMachine != undefined &&
  //           subChapters[i].isBrochure != undefined &&
  //           !subChapters[i].isMachine &&
  //           subChapters[i].isBrochure
  //         )
  //       ) {
  //         this.setState({
  //           exbTableErr: "Please Enter all Length",
  //         });
  //         iserror = true;
  //         lengthErr = "Please Enter all Length";
  //       }
  //     } else if (
  //       subChapters[i].Breadth == "" ||
  //       subChapters[i].Breadth == null ||
  //       subChapters[i].Breadth == 0
  //     ) {
  //       if (
  //         DueDateValidation &&
  //         !(
  //           subChapters[i].isMachine != undefined &&
  //           subChapters[i].isBrochure != undefined &&
  //           !subChapters[i].isMachine &&
  //           subChapters[i].isBrochure
  //         )
  //       ) {
  //         iserror = true;
  //         lengthErr = "Please Enter all Breadth";
  //         this.setState({
  //           exbTableErr: "Please Enter all Breadth",
  //         });
  //       }
  //     } else if (
  //       subChapters[i].Height == "" ||
  //       subChapters[i].Height == null ||
  //       subChapters[i].Height == 0
  //     ) {
  //       if (
  //         DueDateValidation &&
  //         !(
  //           subChapters[i].isMachine != undefined &&
  //           subChapters[i].isBrochure != undefined &&
  //           !subChapters[i].isMachine &&
  //           subChapters[i].isBrochure
  //         )
  //       ) {
  //         iserror = true;
  //         lengthErr = "Please Enter all Height";
  //         this.setState({
  //           exbTableErr: "Please Enter all Height",
  //         });
  //       }
  //     } else if (!isAllMB) {
  //       iserror = true;
  //       lengthErr = "Please Select Machine/Brochure";
  //       this.setState({
  //         exbTableErr: "Please Select Machine/Brochure",
  //       });
  //     } else if (subChapters[i].ManufacturerName == "" || subChapters[i].ManufacturerName == null) {
  //       iserror = true;
  //       lengthErr = "Please Enter all Manufacturer Name";
  //       this.setState({
  //         exbTableErr: "Please Enter all Manufacturer Name",
  //       });
  //     } else if (
  //       subChapters[i].ManufacturingCountry == "" ||
  //       subChapters[i].ManufacturingCountry == null
  //     ) {
  //       this.setState({
  //         exbTableErr: "Please Select all Manufacturer Country",
  //       });
  //       iserror = true;
  //       lengthErr = "Please Select all Manufacturer Country";
  //     }
  //   }
  //   if (totalEnterSpace > area) {
  //     iserror = true;
  //     lengthErr = "Length and breadth must be below or equal to stall area.";
  //     this.setState({ exbTableErr: "Length and breadth must be below or equal to stall area." });
  //   }
  //   if (iserror) {
  //     toastError(lengthErr != "" ? lengthErr : "Please fill mandatory fields");
  //     return;
  //   }

  //   if (!iserror && exbTableErr == "") {
  //     if (
  //       parseFloat(this.state.oldInternationalArea) != parseFloat(InternationalArea) &&
  //       !this.state.isUpdatePerm
  //     ) {
  //       this.setState({ isLoading: true });
  //       this.props
  //         .updateSpacebookingEstimate_action(
  //           this.state.stallArea,
  //           this.state.area,
  //           this.state.stallTypeId,
  //           this.state.openSlides,
  //           this.state.isDoubleStorey,
  //           this.state.doubleStoreyArea != "" && this.state.doubleStoreyArea != null
  //             ? this.state.doubleStoreyArea
  //             : 0,
  //           this.state.InternationalArea != "" && this.state.InternationalArea != null
  //             ? this.state.InternationalArea
  //             : 0
  //         )
  //         .then((data) => {
  //           if (data.error != 1) {
  //             console.log(data.data[0]);
  //             for (var i = 0; i < data.data[0].length; i++) {
  //               if (data.data[0][i].Description.includes("--"))
  //                 data.data[0][i].Description = data.data[0][i].Description.replace(/--/g, " ");
  //             }
  //             this.setState({
  //               newestimateDetails: data.data[0].length > 0 ? data.data[0] : "",
  //               estimatePop: true,
  //             });
  //             this.setState({ isLoading: false });
  //           } else {
  //             this.setState({ isLoading: false });
  //             toastError(data.msg);
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     } else {
  //       this.setState({ isLoading: true });
  //       this.props
  //         .updateExhibitorDetails_action(
  //           list,
  //           Remark,
  //           this.state.InternationalArea != "" && this.state.InternationalArea != null
  //             ? this.state.InternationalArea
  //             : 0,
  //           this.state.textEntries,
  //           this.state.CompanyInformation,
  //           this.state.filePath,
  //           this.state.fileName,
  //           this.state.fileType
  //         )
  //         .then((data) => {
  //           if (data.error != 1) {
  //             console.log("updatedetails", data.data);
  //             toastSuccess("Data Updated Successfully");
  //             setTimeout(() => {
  //               this.setState({ isLoading: false, isUpdatePerm: false, estimatePop: false });
  //               this.handleCancel();
  //             }, 300);
  //           } else {
  //             this.setState({ isLoading: false, isUpdatePerm: false, estimatePop: false });
  //             toastError(data.msg);
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     }
  //   } else {
  //     toastError("Please Correct Length And Breadth Size");
  //   }
  // }

  //   renderBrochurePreview = () => {
  //   const fileUrl = this.state.brochureFilePath;
  //   if (!fileUrl) return null;

  //   const isImage = fileUrl.endsWith(".jpg") || fileUrl.endsWith(".png") || fileUrl.endsWith(".jpeg");
  //   const isPDF = fileUrl.endsWith(".pdf");

  //   if (isImage) {
  //     return (
  //       <img
  //         src={fileUrl}
  //         alt="Brochure preview"
  //         style={{ width: "180px", borderRadius: "8px", border: "1px solid #ccc" }}
  //       />
  //     );
  //   }

  //   if (isPDF) {
  //     return (
  //       <a
  //         href={fileUrl}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         style={{ textDecoration: "underline", color: "#007bff" }}
  //       >
  //         View PDF
  //       </a>
  //     );
  //   }

  //   return <p>Unsupported file type</p>;
  // };

  updateExhibitorDetails() {
    const { subChapters, compareObjArr, exbTableErr, Remark, countryId, stallAreaName, isAllBro, area, isDoubleStorey, stallAreaList, stallTypeId, stallArea, openSlides, lengthWidthErr, InternationalArea } = this.state;

    // Per-field validation: show individual warnings for each empty mandatory field
    const hasBrochure = this.state.fileName && this.state.fileName.toString().trim() !== "";
    const hasKeywords = Array.isArray(this.state.textEntries)
      ? this.state.textEntries.length > 0
      : !!(this.state.inputText && this.state.inputText.toString().trim() !== "");
    const hasRemark = Remark && Remark.toString().trim() !== "";
    const hasCompanyInfo =
      this.state.CompanyInformation && this.state.CompanyInformation.toString().trim() !== "";

    // Reset field error states
    this.setState({
      CompanyInformationErr: "",
      textEntriesErr: "",
      brochureErr: "",
      RemarkErr: "",
    });

    let validationFailed = false;

    // if (!hasCompanyInfo) {
    //   this.setState({ CompanyInformationErr: "Company Information can't be empty" });
    //   toastError("Company Information can't be empty");
    //   validationFailed = true;
    // }

    // if (!hasBrochure) {
    //   this.setState({ brochureErr: "Brochure Document can't be empty" });
    //   toastError("Brochure Document can't be empty");
    //   validationFailed = true;
    // }

    // if (!hasKeywords) {
    //   this.setState({ textEntriesErr: "Technical & Marketing Keyword can't be empty" });
    //   toastError("Technical & Marketing Keyword can't be empty");
    //   validationFailed = true;
    // }

    // if (!hasRemark) {
    //   this.setState({ RemarkErr: "Remark can't be empty" });
    //   toastError("Remark can't be empty");
    //   validationFailed = true;
    // }

    if (validationFailed) return;


    var iserror = false
    if (this.state.stallArea == '' || this.state.stallArea == null || this.state.stallTypeId == '' || this.state.stallTypeId == null || this.state.openSlides == '' || this.state.openSlides == null || (this.state.isDoubleStorey && this.state.doubleStoreyArea == '') || (this.state.isDoubleStorey && this.state.doubleStoreyArea == null) || this.state.InternationalArea == null) {
      console.log(this.state.stallArea, this.state.stallTypeId, this.state.openSlides, this.state.isDoubleStorey, this.state.doubleStoreyArea, this.state.InternationalArea)
      console.log(this.state.stallArea == '', this.state.stallArea == null, this.state.stallTypeId == '', this.state.stallTypeId == null, this.state.openSlides == '', this.state.openSlides == null, (this.state.isDoubleStorey && this.state.doubleStoreyArea == ''), (this.state.isDoubleStorey && this.state.doubleStoreyArea == null), this.state.InternationalArea == '', this.state.InternationalArea == null)

      iserror = true
    }
    if (stallTypeId == '') {
      this.setState({
        stallTypeIdErr: 'Please select scheme type'
      })
      iserror = true
    }
    if (stallArea == '') {
      this.setState({
        stallAreaErr: 'Please select stall area'
      })
      iserror = true
    }
    if (openSlides == '') {
      this.setState({
        openSlidesErr: 'Please select open sides'
      })
      iserror = true
    }
    if (subChapters.length == 0) {
      console.log("exhibitDetailsList", subChapters)
      this.setState({
        exhibitDetailsTableErr: 'Please select atleast one chapter'
      })
      iserror = true
    }
    var lengthErr = ''
    if (lengthWidthErr != '') {
      console.log("exhibitDetailsList", subChapters)
      // this.setState({
      //     exhibitDetailsTableErr: 'Please select atleast one chapter'
      // })
      iserror = true
      lengthErr = lengthWidthErr
    }
    const isAllMB = subChapters.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined ? (item.isMachine || item.isBrochure || item.IsAccessory) : false)
    subChapters.every(item => console.log(item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined, (item.isMachine, item.isBrochure)))
    for (var i = 0; i < subChapters.length; i++) {
      if (!isAllMB) {
        console.log("-------------------------------------------------------------------mb4")
        iserror = true
        lengthErr = "Please Select Machine/Brochure/Accessories"
        this.setState({
          lengthWidthErr: "Please Select Machine/Brochure/Accessories"
        })
      } else if (subChapters[i].ManufacturerName == '' || subChapters[i].ManufacturerName == null) {
        console.log("-------------------------------------------------------------------mb5")
        iserror = true
        lengthErr = "Please Enter all Manufacturer Name"
        this.setState({
          lengthWidthErr: "Please Enter all Manufacturer Name"
        })
      } else if (subChapters[i].ManufacturingCountry == '' || subChapters[i].ManufacturingCountry == null) {
        console.log("-------------------------------------------------------------------mb6")
        this.setState({
          lengthWidthErr: 'Please Select all Manufacturer Country'
        })
        iserror = true
        lengthErr = "Please Select all Manufacturer Country"

      } else if (subChapters[i].Length == '' || subChapters[i].Length == 0 || subChapters[i].Length == null) {
        console.log("-------------------------------------------------------------------mb1")
        if (this.state.isMachineMandatory ? !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory)) : true && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory))) {
          this.setState({
            lengthWidthErr: "Please Enter all Length"
          })
          iserror = true
          lengthErr = "Please Enter all Length"
        }
      } else if (subChapters[i].Breadth == '' || subChapters[i].Breadth == null || subChapters[i].Breadth == 0) {
        console.log("-------------------------------------------------------------------mb2")
        if (this.state.isMachineMandatory ? !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory)) : true && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory))) {
          iserror = true
          lengthErr = "Please Enter all Breadth"
          this.setState({
            lengthWidthErr: "Please Enter all Breadth"
          })
        }
      } else if (subChapters[i].Height == '' || subChapters[i].Height == null || subChapters[i].Height == 0) {
        console.log("-------------------------------------------------------------------mb3")
        if (this.state.isMachineMandatory ? !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory)) : true && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory))) {
          iserror = true
          lengthErr = "Please Enter all Height"
          this.setState({
            lengthWidthErr: "Please Enter all Height"
          })
        }
      }
    }
    var lenerr = ''
    var isSSIvalidAndTable = true
    const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    var isIntBrochure = filterArray.some((item) => !item.isMachine && (item.isBrochure || item.IsAccessory))
    // var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    var totalNational = filterArrayNational.length > 0 ? filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0) : area - InternationalArea
    console.log(filterArray, filterArrayNational)
    console.log(this.state.InternationalArea, InternationalArea != 0,)
    if (countryId == 91 && filterArray.length > 0) {
      var inLimit = false
      var totalArea = totalNational + InternationalArea
      var natAreaErr = false
      if (!isAllBro) {
        if (stallTypeId == 1) {
          if (totalNational < 27) {
            totalArea = InternationalArea + 27
            natAreaErr = true
          }
        } else if (stallTypeId == 2) {
          if (totalNational < 18) {
            totalArea = InternationalArea + 18
            natAreaErr = true
          }
        }
      }
      console.log(totalArea, InternationalArea, totalNational, 'totalNationaltotalNationaltotalNational')
      if (natAreaErr) {
        for (var i = 0; i < stallAreaList.length; i++) {
          if (totalArea <= stallAreaList[i].StallArea) {
            inLimit = true
            this.setState({
              expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: 3, enableArea: true
              // natAreaErr: true 
            })
            return
          }
        }
        if (!inLimit) {
          this.setState({ enableArea: true, enableScheme: true })
          if (this.state.stallTypeId == 2) {
            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
          } else {
            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
          }
        }
        iserror = true;
      }
      else {
        if (totalArea > area) {
          for (var i = 0; i < stallAreaList.length; i++) {
            if (totalArea <= stallAreaList[i].StallArea) {
              inLimit = true
              this.setState({ expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: InternationalArea > area ? 1 : 2, enableArea: true })
              return
            }
          }
          if (!inLimit) {
            this.setState({ enableArea: true, enableScheme: true })
            if (this.state.stallTypeId == 2) {
              this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
              lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
            } else {
              this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
              lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
            }
          }
          // this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
          iserror = true;
        }
      }

      // if (totalInternational != 0) {
      //     if (area >= totalInternational) {
      //         this.setState({ lengthWidthErr: '' })
      //     } else {
      //         this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
      //         iserror = true;
      //     }
      // } else {
      //     var remArea = 0
      //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
      //         // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
      //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
      //             remArea = area - internationalAreaSlabList[i].MinArea
      //             // total = internationalAreaSlabList[i].MinArea
      //         }
      //     }
      //     if (remArea < (totalInternational + totalNational)) {
      //         this.setState({ lengthWidthErr: "Total sum of area cannot be greater than remaining stall area" })
      //         iserror = true;
      //         // isSSIvalidAndTable = false
      //     } else {
      //         this.setState({ lengthWidthErr: '' })
      //     }
      // }
    } else {
      var totalArea = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
      if (area < totalArea) {
        var inLimit = false
        // this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
        for (var i = 0; i < stallAreaList.length; i++) {
          if (totalArea < stallAreaList[i].StallArea) {
            inLimit = true
            console.log(stallAreaList[i].Code, 'stallAreaList[i].Code')
            this.setState({ expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: 2, enableArea: true })
            return
          }
        }
        if (!inLimit) {
          this.setState({ enableArea: true, enableScheme: true })
          if (this.state.stallTypeId == 2) {
            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
          } else {
            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
          }
        }
        iserror = true;
      } else {
        this.setState({ lengthWidthErr: '' })
        lenerr = ''
      }
    }

    for (var i = 0; i < subChapters.length; i++) {
      if (subChapters[i].ManufacturingCountry != '' && subChapters[i].ManufacturingCountry != null) {
        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
          if (this.state.isSSi) {
            toastError("SSI is not applicable for Mixed Exhibitors")
            isSSIvalidAndTable = false
          }
        }
      }
    }
    if (!isSSIvalidAndTable) {
      return
    }

    var prodList = []
    for (var i = 0; i < subChapters.length; i++) {
      // console.log("onEnterProductName validate : ", index, ' ', i, ' ', exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase(), ' ', e.target.value.toString().trim().toLowerCase())
      if (!prodList.includes(subChapters[i].ChapterName.toString().trim().toLowerCase())) {
        prodList.push(subChapters[i].ChapterName.toString().trim().toLowerCase())
      } else {
        this.setState({ lengthWidthErr: 'Product name must be unique.' })
        lenerr = 'Product name must be unique.'
        iserror = true;
      }
    }
    if (iserror) {
      setTimeout(() => {
        toastError(lenerr != '' ? lenerr : lengthErr != '' ? lengthErr : "Please fill mandatory fields")
      }, 500);
      return
    }
    const list = [];
    subChapters.map((data) => {
      var data = {
        ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID")),
        ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
        ChapterID: data.ChapterID,
        ChapterName: data.ChapterName,
        HSNCode: data.HSNCode,
        MachineDetails: data.MachineDetails,
        Length: data.Length,
        Breadth: data.Breadth,
        Height: data.Height,
        FloorCapacity: data.FloorCapacity,
        MachineWeight: data.MachineWeight,
        ManufacturerName: data.ManufacturerName,
        ManufacturingCountry: data.ManufacturingCountry,
        isMachine: data.isMachine,
        isBrochure: data.isBrochure,
        'IsAccessory': data.IsAccessory,
        'DocumentFile': data.DocumentFile,
        'DocumentName': data.DocumentName,
        'DocumentPath': data.DocumentPath,
        'DocumentType': data.DocumentType,
        'DocDeleted': data.DocDeleted,
      };
      list.push(data);
    });

    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    var toShowPop = false
    if (this.state.stallArea != this.state.oldstallArea) {
      toShowPop = true
    }
    if (this.state.stallTypeId != this.state.oldstallTypeId) {
      toShowPop = true
    }
    if (this.state.InternationalArea != this.state.oldInternationalArea) {
      toShowPop = true
    }
    if ((toShowPop) && this.state.isUpdatePerm == false) {
      this.setState({ isLoading: true })
      this.props.updateSpacebookingEstimate_action(this.state.stallArea, this.state.area, this.state.stallTypeId, this.state.openSlides, this.state.isDoubleStorey, this.state.isDoubleStorey ? this.state.doubleStoreyArea : null, JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() == 'india' ? this.state.InternationalArea != "" && this.state.InternationalArea != null ? this.state.InternationalArea : 0 : 0, this.state.isSSi)
        .then((data) => {
          if (data.error != 1) {
            console.log(data.data[0])
            for (var i = 0; i < data.data[0].length; i++) {
              if (data.data[0][i].Description.includes("--")) {
                data.data[0][i].Description = data.data[0][i].Description.replace(/\n/g, ' ')
                data.data[0][i].Description = data.data[0][i].Description.replace(/--/g, '\n')
              }
            }
            this.setState({
              newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
              estimatePop: true
            })
            this.setState({ isLoading: false })

          } else {
            this.setState({ isLoading: false })
            toastError(data.msg)
          }
        }).catch((err) => {
          console.log(err)
        })

    } else {
      for (var a = 0; a < compareObjArr.length; a++) {
        if (compareObjArr[a].name == "stallTypeId") {
          for (var b = 0; b < this.state.stallTypeIdList.length; b++) {
            if (stallTypeId == this.state.stallTypeIdList[b].Code) {
              compareObjArr[a].newValue = this.state.stallTypeIdList[b].Description
            }
            if (compareObjArr[a].oldValue == this.state.stallTypeIdList[b].Code) {
              compareObjArr[a].oldValue = this.state.stallTypeIdList[b].Description
            }
          }
        }
        if (compareObjArr[a].name == "area") { compareObjArr[a].newValue = this.state.area }
        if (compareObjArr[a].name == "openSlides") {
          for (var b = 0; b < this.state.openSideList.length; b++) {
            if (openSlides == this.state.openSideList[b].OpenSidesID) {
              compareObjArr[a].newValue = this.state.openSideList[b].OpenSideName
            }
            if (compareObjArr[a].oldValue == this.state.openSideList[b].OpenSidesID) {
              compareObjArr[a].oldValue = this.state.openSideList[b].OpenSideName
            }
          }
        }
        if (compareObjArr[a].name == "doubleStoreyArea") { compareObjArr[a].newValue = this.state.isDoubleStorey ? parseFloat(this.state.doubleStoreyArea) : 0 }
        if (compareObjArr[a].name == "InternationalArea") { compareObjArr[a].newValue = this.state.isShowInternationalArea ? parseFloat(InternationalArea) : 0 }
        if (compareObjArr[a].name == "ExibitChapterList") { compareObjArr[a].newValue = this.state.subChapters.length }
        if (compareObjArr[a].name == "ExibitChapterList") {
          if (compareObjArr[a].newValue != compareObjArr[a].oldValue) {
            for (var b = 0; b < compareObjArr.length; b++) {
              if (compareObjArr[b].name == 'isExhibitDetailsModify') {
                compareObjArr[b].newValue = 'Yes'
                compareObjArr[b].isUpdated = true
              }
            }
          } else {
            var isChange = false
            for (var b = 0; b < subChapters.length; b++) {
              if (this.state.oldsubChapters[b].Breadth != subChapters[b].Breadth) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].Area != subChapters[b].Area) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].ChapterID != subChapters[b].ChapterID) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].DocumentType != subChapters[b].DocumentType) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].FloorCapacity != subChapters[b].FloorCapacity) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].HSNCode != subChapters[b].HSNCode) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].Height != subChapters[b].Height) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].IsAccessory != subChapters[b].IsAccessory) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].Length != subChapters[b].Length) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].MachineDetails != subChapters[b].MachineDetails) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].MachineWeight != subChapters[b].MachineWeight) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].ManufacturerName != subChapters[b].ManufacturerName) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].ManufacturingCountry != subChapters[b].ManufacturingCountry) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].isBrochure != subChapters[b].isBrochure) {
                isChange = true
              }
              if (this.state.oldsubChapters[b].isMachine != subChapters[b].isMachine) {
                isChange = true
              }
            }
            if (isChange) {
              for (var b = 0; b < compareObjArr.length; b++) {
                if (compareObjArr[b].name == 'isExhibitDetailsModify') {
                  compareObjArr[b].newValue = 'Yes'
                  compareObjArr[b].isUpdated = true
                }
              }
            }
          }
        }

      }
      for (var a = 0; a < compareObjArr.length; a++) {
        if (compareObjArr[a].name != 'isExhibitDetailsModify') {
          if (compareObjArr[a].newValue != compareObjArr[a].oldValue) {
            compareObjArr[a].isUpdated = true
          } else {
            compareObjArr[a].isUpdated = false
          }
        }
      }
      this.setState({
        compareObjArr: compareObjArr
      }, () => {
        this.setState({ isLoading: true });
        this.props
          .updateExhibitorDetails_action(
            list,
            Remark,
            countryId == 91 ? this.state.InternationalArea != "" && this.state.InternationalArea != null
              ? this.state.InternationalArea
              : 0 : 0,
            this.state.textEntries,
            this.state.CompanyInformation,
            this.state.filePath,
            this.state.fileName,
            this.state.fileType,
            ManualFormsID,
            ServiceID,
            VendorDetails, compareObjArr, this.state.area, this.state.stallTypeId, this.state.stallArea, this.state.isUpdatePerm
          )
          .then((data) => {
            if (data.error != 1) {
              console.log("updatedetails", data.data);
              toastSuccess("Data Updated Successfully");
              this.setState({ isLoading: false });
              setTimeout(() => {
                this.setState({ isLoading: false, isUpdatePerm: false, estimatePop: false });
                this.handleCancel();
              }, 2000);
            } else {
              this.setState({ isLoading: false, isUpdatePerm: false, estimatePop: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
    }
  }

  // Get Fill List
  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true });
      this.props
        .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
        .then((data) => {
          if (data.error != 1) {
            if (actionID === primaryChapterListActionId) {
              async function seqnoFormat(arr) {
                for (var i = 0; i < arr.length; i++) {
                  if (arr[i].seqno != "" && arr[i].seqno != null) {
                    arr[i].ChapterName.trim();
                    // console.log(arr[i].ChapterName)
                    if (/^\d$/.test(arr[i].ChapterName[0])) {
                      for (var j = 0; j < arr[i].ChapterName.length; j++) {
                        if (arr[i].ChapterName[j] == " ") {
                          var str = arr[i].ChapterName.slice(j);
                          var finalName = arr[i].seqno + str;
                          arr[i].ChapterName = finalName;
                          // console.log("primaryChapterListActionId 121212", i, finalName)
                          break;
                        }
                      }
                    } else {
                      var str = arr[i].ChapterName;
                      var finalName = arr[i].seqno + " " + str;
                      arr[i].ChapterName = finalName;
                    }
                  }
                }
                return;
              }

              //bubble sort
              for (var i = 0; i < data.data["primaryChapter"].length; i++) {
                for (var j = 0; j < data.data["primaryChapter"].length - 1 - i; j++) {
                  var seq1 = data.data["primaryChapter"][j].seqno;
                  var seq2 = data.data["primaryChapter"][j + 1].seqno;
                  if (parseFloat(seq1) > parseFloat(seq2)) {
                    var temp = data.data["primaryChapter"][j];
                    data.data["primaryChapter"][j] = data.data["primaryChapter"][j + 1];
                    data.data["primaryChapter"][j + 1] = temp;
                    // console.log(i, j, arr[j])
                  }
                }
                if (
                  data.data["primaryChapter"][i].seqno == null ||
                  data.data["primaryChapter"][i].seqno == undefined
                ) {
                  console.log(data.data["primaryChapter"][i].seqno, i);
                }
                // seqnoFormat(data.data['primaryChapter'])
              }
              for (var i = 0; i < data.data["level2"].length; i++) {
                for (var j = 0; j < data.data["level2"].length - 1 - i; j++) {
                  var seq1 = data.data["level2"][j].seqno;
                  var seq2 = data.data["level2"][j + 1].seqno;
                  if (parseFloat(seq1) > parseFloat(seq2)) {
                    var temp = data.data["level2"][j];
                    data.data["level2"][j] = data.data["level2"][j + 1];
                    data.data["level2"][j + 1] = temp;
                    // console.log(i, j, arr[j])
                  }
                }
                if (
                  data.data["level2"][i].seqno == null ||
                  data.data["level2"][i].seqno == undefined
                ) {
                  console.log(data.data["level2"][i].seqno, i);
                }
                seqnoFormat(data.data["level2"]);
              }
              console.log("prr", data.data["level2"]);
              for (var i = 0; i < data.data["level3"].length; i++) {
                for (var j = 0; j < data.data["level3"].length - 1 - i; j++) {
                  var seq1 = data.data["level3"][j].seqno;
                  seq1 = seq1 != null && seq1.replaceAll(".", "");
                  var seq2 = data.data["level3"][j + 1].seqno;
                  seq2 = seq2 != null && seq2.replaceAll(".", "");

                  if (parseFloat(seq1) > parseFloat(seq2)) {
                    var temp = data.data["level3"][j];
                    data.data["level3"][j] = data.data["level3"][j + 1];
                    data.data["level3"][j + 1] = temp;
                  }
                }
                if (
                  data.data["level3"][i].seqno == null ||
                  data.data["level3"][i].seqno == undefined
                ) {
                  console.log(data.data["level3"][i].seqno, i);
                }
                seqnoFormat(data.data["level3"]);
              }
              for (var i = 0; i < data.data["level4"].length; i++) {
                for (var j = 0; j < data.data["level4"].length - 1 - i; j++) {
                  var seq1 = data.data["level4"][j].seqno;
                  seq1 = seq1 != null && seq1.replaceAll(".", "");
                  var seq2 = data.data["level4"][j + 1].seqno;
                  seq2 = seq2 != null && seq2.replaceAll(".", "");
                  if (parseFloat(seq1) > parseFloat(seq2)) {
                    var temp = data.data["level4"][j];
                    data.data["level4"][j] = data.data["level4"][j + 1];
                    data.data["level4"][j + 1] = temp;
                    // console.log(i, j, arr[j])
                  }
                }
                if (
                  data.data["level4"][i].seqno == null ||
                  data.data["level4"][i].seqno == undefined
                ) {
                  console.log(data.data["level4"][i].seqno, i);
                }
                seqnoFormat(data.data["level4"]);
              }

              for (var i = 0; i < data.data["level2"].length; i++) {
                data.data["level2"][i].isHighlight = false;
              }
              this.setState({
                primaryChapterListData: data.data["primaryChapter"],
                level0: data.data["level0"],
                level2: data.data["level2"],
                level3: data.data["level3"],
                level4: data.data["level4"],
                isLoading: false,
              });
              setTimeout(() => {
                this.filterLevelData();
              }, 300);
            }
            if (actionID === countryActionId) {
              console.log("country data", data.data);
              this.setState({
                countryList: data.data,
                tempCountryList: data.data,
                billTempCountryList: data.data,
                isLoading: false,
              });
            }
          }
          if (actionID === fullStallAreaActionId) {
            // console.log("country data", data.data)
            this.setState({
              referenceStallAreaArr: data.data,
            })
            resolve(true)
          }
          if (actionID === stallTypeActionId) {
            // console.log("country data", data.data)
            this.setState({
              stallTypeIdList: data.data,
            });
            if (data.data.length == 1) {
              this.onstallTypeIdChange(null, data.data[0].Code);
            }
            // resolve(true)
          }
          if (actionID === internationalAreaSlabActionId) {
            // console.log("country data", data.data)
            this.setState({
              internationalAreaSlabList: data.data,
            });
            resolve(true);
          }
          if (actionID === openSideListActionId) {
            // console.log("country data", data.data)
            this.setState({
              openSideList: data.data,
            });
            // resolve(true)
          }
          // stall Size
          if (actionID === stallSizeActionId) {
            // console.log("country data", data.data)
            this.setState({
              stallAreaList: data.data,
            });
            if (this.state.stallArea != "") {
              for (var i = 0; i < data.data.length; i++) {
                if (data.data[i].Code == this.state.stallArea) {
                  console.log("Description : ", data.data[i].Description);
                  this.setState({ stallAreaName: data.data[i].Description });
                }
              }
            }
            // resolve(true)
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    });
  }

  filterLevelData() {
    const { level2, level3, level4 } = this.state;
    var newLevel = [...level2];
    for (var i = 0; i < level3.length; i++) {
      var tempLevel4 = [];
      for (var j = 0; j < level4.length; j++) {
        if (level3[i]["ChapterID"] == level4[j]["ParentChapterID"]) {
          tempLevel4.push(level4[j]);
        }
      }
      level3[i]["level_four_List"] = tempLevel4;
      // console.log(" level3[i]['level_four_List']", tempLevel4);
    }

    for (var i = 0; i < newLevel.length; i++) {
      var tempLevel3 = [];
      for (var j = 0; j < level3.length; j++) {
        if (newLevel[i]["ChapterID"] == level3[j]["ParentChapterID"]) {
          tempLevel3.push(level3[j]);
        }
      }
      newLevel[i]["level_third_List"] = tempLevel3;
      // console.log("level2[i]['level_third_List']", tempLevel3);
    }

    ///////////============
    console.log("level2", newLevel);
    this.setState({ level2: newLevel });
  }

  // Get  Details
  getExhibitorDetails() {
    this.setState({ isLoading: true });
    this.props
      .getExhibitorDetails_action()
      .then((data) => {
        if (data.error != 1) {
          const backendKeywords = data.data.technicalMarketingKeywordList || [];

          const mappedKeywords = backendKeywords.map((item, index) => ({
            id: index + 1,
            text: item.Keyword,
          }));
          this.setState({
            Remark: data.data["primaryChapterHeaderDetails"][0]["Remark"],
            textEntries: mappedKeywords,
            CompanyInformation: data.data.exhibitDetails[0].companyProfile,
            isDoubleStoreyExhibition: JSON.parse(
              sessionStorage.getItem("isDoubleStoreyExhibition")
            ),
            fileName: data.data.exhibitDetails[0].BrochureDocument
              ? data.data.exhibitDetails[0].BrochureDocument.split("/").pop()
              : "",
            filePath: data.data.exhibitDetails[0].BrochureDocument || "",
            fileIsFromBackend: data.data.exhibitDetails[0].BrochureDocument ? true : false,
          });
          const countryId = data.data["registrationDetails"][0]["CountryID"]
            ? data.data["registrationDetails"][0]["CountryID"]
            : "";
          this.getFillList(countryActionId, "", "", countryId, "", "");
          this.getFillList(
            stallTypeActionId,
            sessionStorage.getItem("sessionExhibitionID"),
            "",
            "",
            "",
            ""
          );
          this.getFillList(
            openSideListActionId,
            sessionStorage.getItem("sessionExhibitionID"),
            "",
            "",
            "",
            ""
          );

          var minAreaAsModule = 0;
          for (var i = 0; i < this.state.subChapters.length; i++) {
            if (parseInt(data.data["primaryChapterHeaderDetails"][0].StallTypeID) == 1) {
              console.log("subChapters[i].MinBareArea", this.state.subChapters[i].MinBareArea);
              if (
                this.state.subChapters[i].MinBareArea != "" &&
                this.state.subChapters[i].MinBareArea != null
              ) {
                if (minAreaAsModule < this.state.subChapters[i].MinBareArea) {
                  minAreaAsModule = this.state.subChapters[i].MinBareArea;
                }
              }
            } else if (parseInt(data.data["primaryChapterHeaderDetails"][0].StallTypeID) == 2) {
              if (
                this.state.subChapters[i].MinShellArea != "" &&
                this.state.subChapters[i].MinShellArea != null
              ) {
                if (minAreaAsModule < this.state.subChapters[i].MinShellArea) {
                  minAreaAsModule = this.state.subChapters[i].MinShellArea;
                }
              }
            }
          }
          console.log(
            "level2.length00000000000000000",
            parseInt(data.data["primaryChapterHeaderDetails"][0].StallTypeID),
            minAreaAsModule,
            this.state.subChapters
          );
          for (var i = 0; i < data.data["estimateNote"].length; i++) {
            if (data.data["estimateNote"][i].NoteType == "exhibit details") {
              this.state.ExhibitDetailsNote.push(data.data["estimateNote"][i]);
            }
          }
          this.getFillList(
            stallSizeActionId,
            sessionStorage.getItem("sessionExhibitionID"),
            minAreaAsModule == 0 ? "" : minAreaAsModule,
            data.data["primaryChapterHeaderDetails"][0].StallTypeID,
            countryId,
            ""
          );
          this.getFillList(
            fullStallAreaActionId,
            sessionStorage.getItem("sessionExhibitionID"),
            minAreaAsModule == 0 ? "" : minAreaAsModule,
            data.data["primaryChapterHeaderDetails"][0].StallTypeID,
            countryId,
            ""
          );

          // Chapter Level 2 Level 3 And Level 4
          var allChap = [];
          const lev2 = data.data["primaryChapterListDetails"]["level2"].filter(
            (obj) => obj.IsSelect == true
          );
          allChap.push(...lev2);
          const lev3 = data.data["primaryChapterListDetails"]["level3"].filter(
            (obj) => obj.IsSelect == true
          );
          allChap.push(...lev3);
          const lev4 = data.data["primaryChapterListDetails"]["level4"].filter(
            (obj) => obj.IsSelect == true
          );
          allChap.push(...lev4);

          // Primary Chapter Stall Area
          const primaryChapterStallArea =
            data.data["primaryChapterHeaderDetails"][0].ExhibitionStallSizeID;

          // Only Sub Chapters
          const finalSubChap = allChap.filter((element) => element.IsCheckbox == true);
          console.log("final chapters", finalSubChap);

          // Setting chapters
          const { level2, level3, level4, internationalAreaSlabList } = this.state;
          console.log("111->>>>>>>>>>>>>>>>>>>>>", level2);
          console.log("222->>>>>>>>>>>>>>>>>>>>>", level3);
          console.log("333->>>>>>>>>>>>>>>>>>>>>", level4);
          level2.length > 0 &&
            level2.map((data) => {
              finalSubChap.length > 0 &&
                finalSubChap.map((item) => {
                  if (data.ChapterID == item.ChapterID) {
                    data.IsSelect = true;
                  }
                });
            });

          level3.length > 0 &&
            level3.map((data) => {
              finalSubChap.length > 0 &&
                finalSubChap.map((item) => {
                  if (data.ChapterID == item.ChapterID) {
                    data.IsSelect = true;
                  }
                });
            });

          level4.length > 0 &&
            level4.map((data) => {
              finalSubChap.length > 0 &&
                finalSubChap.map((item) => {
                  if (data.ChapterID == item.ChapterID) {
                    data.IsSelect = true;
                  }
                });
            });
          // ------
          async function seqnoFormat(arr) {
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].seqno != "" && arr[i].seqno != null) {
                arr[i].ChapterName.trim();
                // console.log(arr[i].ChapterName)
                if (/^\d$/.test(arr[i].ChapterName[0])) {
                  for (var j = 0; j < arr[i].ChapterName.length; j++) {
                    if (arr[i].ChapterName[j] == " ") {
                      var str = arr[i].ChapterName.slice(j);
                      var finalName = arr[i].seqno + str;
                      arr[i].ChapterName = finalName;
                      // console.log("primaryChapterListActionId 121212", i, finalName)
                      break;
                    }
                  }
                } else {
                  var str = arr[i].ChapterName;
                  var finalName = arr[i].seqno + " " + str;
                  arr[i].ChapterName = finalName;
                }
              }
            }
            return;
          }
          for (
            var i = 0;
            i < data.data["primaryChapterListDetails"]["primaryChapter"].length;
            i++
          ) {
            for (
              var j = 0;
              j < data.data["primaryChapterListDetails"]["primaryChapter"].length - 1 - i;
              j++
            ) {
              var seq1 = data.data["primaryChapterListDetails"]["primaryChapter"][j].seqno;
              var seq2 = data.data["primaryChapterListDetails"]["primaryChapter"][j + 1].seqno;
              if (parseFloat(seq1) > parseFloat(seq2)) {
                var temp = data.data["primaryChapterListDetails"]["primaryChapter"][j];
                data.data["primaryChapterListDetails"]["primaryChapter"][j] =
                  data.data["primaryChapterListDetails"]["primaryChapter"][j + 1];
                data.data["primaryChapterListDetails"]["primaryChapter"][j + 1] = temp;
                // console.log(i, j, arr[j])
              }
            }
            if (
              data.data["primaryChapterListDetails"]["primaryChapter"][i].seqno == null ||
              data.data["primaryChapterListDetails"]["primaryChapter"][i].seqno == undefined
            ) {
              console.log(data.data["primaryChapterListDetails"]["primaryChapter"][i].seqno, i);
            }
            // seqnoFormat(data.data['primaryChapterListDetails']['primaryChapter'])
          }
          for (var i = 0; i < data.data["primaryChapterListDetails"]["level2"].length; i++) {
            for (
              var j = 0;
              j < data.data["primaryChapterListDetails"]["level2"].length - 1 - i;
              j++
            ) {
              var seq1 = data.data["primaryChapterListDetails"]["level2"][j].seqno;
              var seq2 = data.data["primaryChapterListDetails"]["level2"][j + 1].seqno;
              if (parseFloat(seq1) > parseFloat(seq2)) {
                var temp = data.data["primaryChapterListDetails"]["level2"][j];
                data.data["primaryChapterListDetails"]["level2"][j] =
                  data.data["primaryChapterListDetails"]["level2"][j + 1];
                data.data["primaryChapterListDetails"]["level2"][j + 1] = temp;
                // console.log(i, j, arr[j])
              }
            }
            if (
              data.data["primaryChapterListDetails"]["level2"][i].seqno == null ||
              data.data["primaryChapterListDetails"]["level2"][i].seqno == undefined
            ) {
              console.log(data.data["primaryChapterListDetails"]["level2"][i].seqno, i);
            }
            seqnoFormat(data.data["primaryChapterListDetails"]["level2"]);
          }
          // console.log("prr", data.data['level2'])
          for (var i = 0; i < data.data["primaryChapterListDetails"]["level3"].length; i++) {
            for (
              var j = 0;
              j < data.data["primaryChapterListDetails"]["level3"].length - 1 - i;
              j++
            ) {
              var seq1 = data.data["primaryChapterListDetails"]["level3"][j].seqno;
              seq1 = seq1 != null && seq1.replaceAll(".", "");
              var seq2 = data.data["primaryChapterListDetails"]["level3"][j + 1].seqno;
              seq2 = seq2 != null && seq2.replaceAll(".", "");

              if (parseFloat(seq1) > parseFloat(seq2)) {
                var temp = data.data["primaryChapterListDetails"]["level3"][j];
                data.data["primaryChapterListDetails"]["level3"][j] =
                  data.data["primaryChapterListDetails"]["level3"][j + 1];
                data.data["primaryChapterListDetails"]["level3"][j + 1] = temp;
              }
            }
            if (
              data.data["primaryChapterListDetails"]["level3"][i].seqno == null ||
              data.data["primaryChapterListDetails"]["level3"][i].seqno == undefined
            ) {
              console.log(data.data["primaryChapterListDetails"]["level3"][i].seqno, i);
            }
            seqnoFormat(data.data["primaryChapterListDetails"]["level3"]);
          }
          for (var i = 0; i < data.data["primaryChapterListDetails"]["level4"].length; i++) {
            for (
              var j = 0;
              j < data.data["primaryChapterListDetails"]["level4"].length - 1 - i;
              j++
            ) {
              var seq1 = data.data["primaryChapterListDetails"]["level4"][j].seqno;
              seq1 = seq1 != null && seq1.replaceAll(".", "");
              var seq2 = data.data["primaryChapterListDetails"]["level4"][j + 1].seqno;
              seq2 = seq2 != null && seq2.replaceAll(".", "");
              if (parseFloat(seq1) > parseFloat(seq2)) {
                var temp = data.data["primaryChapterListDetails"]["level4"][j];
                data.data["primaryChapterListDetails"]["level4"][j] =
                  data.data["primaryChapterListDetails"]["level4"][j + 1];
                data.data["primaryChapterListDetails"]["level4"][j + 1] = temp;
                // console.log(i, j, arr[j])
              }
            }
            if (
              data.data["primaryChapterListDetails"]["level4"][i].seqno == null ||
              data.data["primaryChapterListDetails"]["level4"][i].seqno == undefined
            ) {
              console.log(data.data["primaryChapterListDetails"]["level4"][i].seqno, i);
            }
            seqnoFormat(data.data["primaryChapterListDetails"]["level4"]);
          }

          for (var i = 0; i < data.data["primaryChapterListDetails"]["level2"].length; i++) {
            data.data["primaryChapterListDetails"]["level2"][i].isHighlight = false;
          }

          var exhibitlist = [];
          // console.log("level2 get", level2)
          data.data['primaryChapterListDetails']['level2'].length > 0 && data.data['primaryChapterListDetails']['level2'].map(level2Data => {
            level2Data.DocumentName = ''
            level2Data.DocumentType = ''
            level2Data.DocumentFile = ''
            level2Data.DocumentPath = ''
            level2Data.DocDeleted = true
            if (level2Data.IsSelect && level2Data.IsCheckbox) {
              // console.log("level2Data get", level2Data)
              var temppath = (level2Data.isMachine || level2Data.IsAccessory) ? level2Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level2Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level2Data.DocumentType = ''
              level2Data.DocumentFile = ''
              level2Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level2Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level2Data.Area = parseFloat(level2Data.Length || 0) * parseFloat(level2Data.Breadth || 0)
              exhibitlist.push(level2Data)
            }
          })
          data.data['primaryChapterListDetails']['level3'].length > 0 && data.data['primaryChapterListDetails']['level3'].map(level3Data => {
            level3Data.DocumentName = ''
            level3Data.DocumentType = ''
            level3Data.DocumentFile = ''
            level3Data.DocumentPath = ''
            level3Data.DocDeleted = true
            if (level3Data.IsSelect && level3Data.IsCheckbox) {
              var temppath = (level3Data.isMachine || level3Data.IsAccessory) ? level3Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level3Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level3Data.DocumentType = ''
              level3Data.DocumentFile = ''
              level3Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level3Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level3Data.Area = parseFloat(level3Data.Length || 0) * parseFloat(level3Data.Breadth || 0)
              exhibitlist.push(level3Data)
            }
          })
          data.data['primaryChapterListDetails']['level4'].length > 0 && data.data['primaryChapterListDetails']['level4'].map(level4Data => {
            level4Data.DocumentName = ''
            level4Data.DocumentType = ''
            level4Data.DocumentFile = ''
            level4Data.DocumentPath = ''
            level4Data.DocDeleted = true
            if (level4Data.IsSelect && level4Data.IsCheckbox) {
              var temppath = (level4Data.isMachine || level4Data.IsAccessory) ? level4Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level4Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level4Data.DocumentType = ''
              level4Data.DocumentFile = ''
              level4Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level4Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level4Data.Area = parseFloat(level4Data.Length || 0) * parseFloat(level4Data.Breadth || 0)
              exhibitlist.push(level4Data)
            }
          })
          exhibitlist.sort((a, b) => (a.ChapterID > b.ChapterID) ? 1 : -1);
          data.data['primaryChapterListDetails']['level0'].length > 0 && data.data['primaryChapterListDetails']['level0'].map(level0Data => {
            level0Data.DocumentName = ''
            level0Data.DocumentType = ''
            level0Data.DocumentFile = ''
            level0Data.DocumentPath = ''
            level0Data.DocDeleted = true
            if (level0Data.IsSelect) {
              // console.log("level2Data get", level2Data)
              var temppath = (level0Data.isMachine || level0Data.IsAccessory) ? level0Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level0Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level0Data.DocumentType = ''
              level0Data.DocumentFile = ''
              level0Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level0Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level0Data.Area = parseFloat(level0Data.Length || 0) * parseFloat(level0Data.Breadth || 0)
              exhibitlist.push(level0Data)
            }
          })
          const totalArea = exhibitlist.reduce((sum, obj) => sum + obj.Area, 0);
          if (data.data["primaryChapterHeaderDetails"][0].StallArea < totalArea) {
            this.setState({ exbTableErr: "Total area of sum cannot be greater than stall area" });
          } else {
            this.setState({ exbTableErr: "" });
          }
          console.log("exhibitlist==", exhibitlist);
          const filterArray = exhibitlist.filter(
            (item) =>
              item.ManufacturingCountry.toLowerCase().trim() != "india" &&
              item.ManufacturingCountry != ""
          );
          var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0);
          if (filterArray.length > 0) {
            for (var i = 0; i < internationalAreaSlabList.length; i++) {
              console.log(data.data["primaryChapterHeaderDetails"][0].StallArea, total);
              if (
                internationalAreaSlabList[i].FromRange <
                data.data["primaryChapterHeaderDetails"][0].StallArea &&
                data.data["primaryChapterHeaderDetails"][0].StallArea <=
                internationalAreaSlabList[i].ToRange
              ) {
                if (total >= internationalAreaSlabList[i].MinArea) {
                  total = total;
                } else {
                  total = internationalAreaSlabList[i].MinArea;
                }
              }
            }
          }
          var isAllBrochure = true
          if (filterArray.length > 0) {
            for (var i = 0; i < filterArray.length; i++) {
              if (filterArray[i].IsAccessory || filterArray[i].isMachine) {
                isAllBrochure = false
              }
            }
          }
          this.setState({
            subChapters: exhibitlist,
            isShowInternationalArea: filterArray.length > 0, isAllBro: filterArray.length > 0 ? isAllBrochure : false
            // InternationalArea: filterArray.length > 0 ? total : 0,
            // oldInternationalArea: filterArray.length > 0 ? total : 0,
          });

          this.setState({
            isLoading: false,
            subChapters: finalSubChap,
            oldsubChapters: finalSubChap,
            stallArea: primaryChapterStallArea,
            oldstallArea: primaryChapterStallArea,
            countryId:
              data.data["registrationDetails"][0]["CountryID"] != null
                ? data.data["registrationDetails"][0]["CountryID"]
                : "",
            regCompany:
              data.data["registrationDetails"][0]["CompanyName"] != null
                ? data.data["registrationDetails"][0]["CompanyName"]
                : "",
            fasciaName:
              data.data["registrationDetails"][0]["FasciaName"] != null
                ? data.data["registrationDetails"][0]["FasciaName"]
                : "",
            personInchFirst:
              data.data["registrationDetails"][0]["PersonIncharge"] != null
                ? data.data["registrationDetails"][0]["PersonIncharge"]
                : "",
            personInchLast:
              data.data["registrationDetails"][0]["LastNamePersonIncharge"] != null
                ? data.data["registrationDetails"][0]["LastNamePersonIncharge"]
                : "",
            regDesignation:
              data.data["registrationDetails"][0]["Designation"] != null
                ? data.data["registrationDetails"][0]["Designation"]
                : "",
            primaryChapterName:
              data.data["registrationDetails"][0]["PrimaryChapterName"] != null &&
                data.data["registrationDetails"][0]["PrimaryChapterName"] != ""
                ? data.data["registrationDetails"][0]["PrimaryChapterName"]
                : "",
            level2:
              data.data["primaryChapterListDetails"]["level2"].length > 0
                ? data.data["primaryChapterListDetails"]["level2"]
                : [],
            level3:
              data.data["primaryChapterListDetails"]["level3"].length > 0
                ? data.data["primaryChapterListDetails"]["level3"]
                : [],
            level4:
              data.data["primaryChapterListDetails"]["level4"].length > 0
                ? data.data["primaryChapterListDetails"]["level4"]
                : [],
            stallArea: primaryChapterStallArea,
            area: data.data["primaryChapterHeaderDetails"][0].StallArea,
            oldarea: data.data["primaryChapterHeaderDetails"][0].StallArea,
            openSlides: data.data["primaryChapterHeaderDetails"][0].OpenSidesID,
            stallTypeId:
              data.data["primaryChapterHeaderDetails"].length > 0
                ? data.data["primaryChapterHeaderDetails"][0].StallTypeID
                : "",
            oldstallTypeId: data.data["primaryChapterHeaderDetails"].length > 0
              ? data.data["primaryChapterHeaderDetails"][0].StallTypeID
              : "",
            isDoubleStorey: data.data["primaryChapterHeaderDetails"][0].isDoubleStorey,
            doubleStoreyArea: data.data["primaryChapterHeaderDetails"][0].DoubleStoreyArea,
          }, () => {
            this.setState({
              compareObjArr: [
                { name: 'stallTypeId', oldValue: this.state.stallTypeId, newValue: this.state.stallTypeId, display: 'Scheme Type' },
                { name: 'area', oldValue: this.state.area, newValue: this.state.area, display: 'Stall Area' },
                { name: 'openSlides', oldValue: this.state.openSlides, newValue: this.state.openSlides, display: 'Open Sides' },
                { name: 'doubleStoreyArea', oldValue: this.state.isDoubleStorey && this.state.doubleStoreyArea != '' && this.state.doubleStoreyArea != null ? this.state.doubleStoreyArea : 0, newValue: this.state.isDoubleStorey && this.state.doubleStoreyArea != '' && this.state.doubleStoreyArea != null ? this.state.doubleStoreyArea : 0, display: 'Double storey Area' },
                // { name: 'InternationalArea', oldValue: this.state.InternationalArea, newValue: this.state.InternationalArea, display: 'International Area' },
                { name: 'ExibitChapterList', oldValue: this.state.subChapters.length, newValue: this.state.subChapters.length, display: 'No of Exhibit details product' },
                { name: 'isExhibitDetailsModify', oldValue: '-', newValue: 'No', display: 'Exhibit Details modified' }
              ]
            })
            setTimeout(() => {
              this.adjustIntAreaNew(data.data['primaryChapterHeaderDetails'][0].StallArea, 1)
            }, 200);
          })
          console.log(allChap);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Change Of Product Name In Exhibit Table
  onEnterProductName(e, index) {
    const { level4, subChapters } = this.state;

    subChapters.map((data, i) => {
      if (index == i) {
        console.log("e.target.value", e.target.value);
        data.ChapterName = e.target.value;
      }
    });

    subChapters.map((data, i) => { });

    for (var i = 0; i < subChapters.length; i++) {
      console.log(
        "onEnterProductName validate : ",
        index,
        " ",
        i,
        " ",
        subChapters[i].ChapterName.toString().trim().toLowerCase(),
        " ",
        e.target.value.toString().trim().toLowerCase()
      );
      if (
        index != i &&
        subChapters[i].ChapterName.toString().trim().toLowerCase() ==
        e.target.value.toString().trim().toLowerCase()
      ) {
        this.setState({ exbTableErr: "Product name must be unique." });
        return;
      } else {
        this.setState({ exbTableErr: "" });
      }
    }

    setTimeout(() => {
      console.log("subChapters", subChapters);
      this.setState({ subChapters: subChapters });
    }, 200);
  }

  // On Machine Details Change In Exhibit Table
  onMachineDetailsChange(e, id, index) {
    const { level4, subChapters } = this.state;
    subChapters.map((data, i) => {
      if (index == i) {
        data.MachineDetails = e.target.value;
      }
    });
    setTimeout(() => {
      this.setState({ subChapters: subChapters });
    }, 100);
  }

  // On HSN No Change In Exhibit Table
  onEnterHSNCode(e, id, index) {
    const { level4, subChapters } = this.state;
    console.log("id", id);

    subChapters.map((data, i) => {
      if (index == i) {
        console.log("data.ChapterID", data.ChapterID);
        console.log("e.target.value", e.target.value);
        data.HSNCode = e.target.value;
      }
    });
    setTimeout(() => {
      console.log("subChapters", subChapters);
      this.setState({ subChapters: subChapters });
    }, 200);
  }

  // On Length Change In Exhibit Table
  onLengthChange(e, id, index) {
    const { level4, subChapters, stallAreaName, area, internationalAreaSlabList } = this.state
    var breadth = 0;
    subChapters.map((data, i) => {
      if (index == i) {
        data.Length = e.target.value.replace(/[^0-9]/g, '')
        breadth = data.Breadth;
        data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
      }
    })
    // if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
    //     breadth != null && breadth != 0) {
    //     var totalSpace;
    //     var totalEnterSpace;
    //     var lengthWidthList
    //     if (stallAreaName.includes('x')) {
    //         lengthWidthList = stallAreaName.split('x');
    //     } else if (stallAreaName.includes('X')) {
    //         lengthWidthList = stallAreaName.split('X');
    //     }
    //     totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
    //     totalEnterSpace = parseFloat(e.target.value) * parseFloat(breadth);
    //     if (totalEnterSpace > totalSpace) {
    //         this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
    //     } else {
    //         this.setState({ lengthWidthErr: '' })
    //     }
    // }
    // const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
    // if (area < totalArea) {
    //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
    // } else {
    //     this.setState({ lengthWidthErr: '' })
    // }

    // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    // var total = 0
    // if (tempTotal == 0) {
    //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
    //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
    //             total = internationalAreaSlabList[i].MinArea
    //         }
    //     }
    // } else {
    //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //     if (totalInternational == 0) {
    //         if ((area - totalNational) > 0) {
    //             total = area - totalNational
    //         } else {
    //             total = 0
    //         }
    //     } else {
    //         if (area >= totalInternational) {
    //             total = totalInternational
    //         } else {
    //             total = 0
    //         }
    //     }
    // }
    // setTimeout(() => {
    //     if (filterArrayBroSome) {
    //         // if (minArea == 0) {
    //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //         //     if ((parseFloat(area) / 2) < totalNational) {
    //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
    //         //     } else {
    //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
    //         //     }
    //         // } else {
    //         this.setState({ InternationalArea: total })
    //         // }
    //         // if (minArea != 0) {
    //         //     this.setState({ InternationalArea: total })
    //         // }
    //     } else {
    //         this.setState({ InternationalArea: 0 })
    //     }
    //     this.setState({ subChapters: subChapters })
    //     this.adjustInternationalArea(area)
    // }, 100);

    // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    // var minArea = 0
    // for (var i = 0; i < internationalAreaSlabList.length; i++) {
    //     console.log(area, total)
    //     if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
    //         if (total >= internationalAreaSlabList[i].MinArea) {
    //             total = total
    //             minArea = total
    //         } else {
    //             total = internationalAreaSlabList[i].MinArea
    //             minArea = internationalAreaSlabList[i].MinArea
    //         }
    //     }
    // }
    // setTimeout(() => {
    //     if (filterArray.length > 0) {
    //         if (minArea == 0) {
    //             const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    //             var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //             if ((parseFloat(area) / 2) < totalNational) {
    //                 this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
    //             } else {
    //                 this.setState({ InternationalArea: (parseFloat(area) / 2) })
    //             }
    //         } else {
    //             this.setState({ InternationalArea: total })
    //         }
    //     } else {
    //         this.setState({ InternationalArea: 0 })
    //     }
    //     this.setState({ subChapters: subChapters })
    //     this.adjustInternationalArea(area)
    // }, 100);
    setTimeout(() => {
      this.adjustIntAreaNew(area)
    }, 100);

  }

  onBreadthChange(e, id, index) {
    const { level4, subChapters, stallAreaName, area, internationalAreaSlabList } = this.state
    var length = 0;
    subChapters.map((data, i) => {
      if (index == i) {
        data.Breadth = e.target.value.replace(/[^0-9]/g, '')
        length = data.Length;
        data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
      }
    })


    // if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
    //     length != null && length != 0) {
    //     var totalSpace;
    //     var totalEnterSpace;
    //     var lengthWidthList
    //     if (stallAreaName.includes('x')) {
    //         lengthWidthList = stallAreaName.split('x');
    //     } else if (stallAreaName.includes('X')) {
    //         lengthWidthList = stallAreaName.split('X');
    //     }

    //     totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
    //     console.log('totalSpace : ', totalSpace);
    //     totalEnterSpace = parseFloat(e.target.value) * parseFloat(length);
    //     if (totalEnterSpace > totalSpace) {
    //         subChapters.map((data, i) => {
    //             if (index == i) {
    //                 data.isLengthValidate = true;
    //             }
    //         })
    //         this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
    //     } else {
    //         subChapters.map((data, i) => {
    //             if (index == i) {
    //                 data.isLengthValidate = false;
    //             }
    //         })
    //         this.setState({ lengthWidthErr: '' })
    //     }
    // }
    // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    // var total = 0
    // if (tempTotal == 0) {
    //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
    //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
    //             total = internationalAreaSlabList[i].MinArea
    //         }
    //     }
    // } else {
    //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //     if (totalInternational == 0) {
    //         if ((area - totalNational) > 0) {
    //             total = area - totalNational
    //         } else {
    //             total = 0
    //         }
    //     } else {
    //         if (area >= totalInternational) {
    //             total = totalInternational
    //         } else {
    //             total = 0
    //         }
    //     }
    // }
    // setTimeout(() => {
    //     if (filterArrayBroSome) {
    //         // if (minArea == 0) {
    //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //         //     if ((parseFloat(area) / 2) < totalNational) {
    //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
    //         //     } else {
    //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
    //         //     }
    //         // } else {
    //         this.setState({ InternationalArea: total })
    //         // }
    //         // if (minArea != 0) {
    //         //     this.setState({ InternationalArea: total })
    //         // }
    //     } else {
    //         this.setState({ InternationalArea: 0 })
    //     }
    //     this.setState({ subChapters: subChapters })
    //     this.adjustInternationalArea(area)
    // }, 100);
    setTimeout(() => {
      this.adjustIntAreaNew(area)
    }, 100);
  }

  onHeightChange(e, id, index) {
    const { level4, subChapters } = this.state
    subChapters.map((data, i) => {
      if (index == i) {
        data.Height = e.target.value
      }
    })
    setTimeout(() => {
      this.setState({ subChapters: subChapters, lengthWidthErr: '' })
    }, 100);

    // if (e.target.value != null && e.target.value != '' && e.target.value != 0 && e.target.value > 3) {
    //     this.setState({ lengthWidthErr: 'Height must be less than or equal to 3.' })
    // } else {
    //     this.setState({ lengthWidthErr: '' })
    // }
  }

  onFloorCapacityChange(e, id, index) {
    const { level4, subChapters } = this.state;
    subChapters.map((data, i) => {
      if (index == i) {
        data.FloorCapacity = e.target.value;
      }
    });
    setTimeout(() => {
      this.setState({ subChapters: subChapters });
    }, 100);
  }

  onMachineWeightChange(e, id, index) {
    const { level4, subChapters } = this.state;
    subChapters.map((data, i) => {
      if (index == i) {
        data.MachineWeight = e.target.value;
      }
    });
    setTimeout(() => {
      this.setState({ subChapters: subChapters });
    }, 100);
  }

  onManufacturerNameChange(e, id, index) {
    const { level4, subChapters, area } = this.state
    subChapters.map((data, i) => {
      if (index == i) {
        data.ManufacturerName = e.target.value
      }
    })
    setTimeout(() => {
      this.setState({ subChapters: subChapters }, () => {
        this.adjustIntAreaNew(area)
      })
    }, 100);
  }

  // On Manufacturing Country Name Change
  onManufacturingCountryChange(e, id, index) {
    const { countryList, tempCountryList, subChapters, area } = this.state;

    subChapters.map((data, i) => {
      if (index == i) {
        // if (e.target.value.toLowerCase().trim() != 'india') {
        //     data.isMachine = false
        // }
        if (e.target.value != "") {
          var searchStateList = tempCountryList.filter((data) => {
            return data.Description.toLowerCase().includes(
              e.target.value.toLowerCase()
            );
          });
          data.ManufacturingCountry = e.target.value
          this.setState({
            tempCountryList: searchStateList,
            isDisplayCountryList: true,
            manufactureCountryIndex: index
          });
        } else {
          data.ManufacturingCountry = e.target.value
          this.setState({
            tempCountryList: countryList,
            isDisplayCountryList: false,
            manufactureCountryIndex: index
          });
        }
      }
    })
    setTimeout(() => {
      this.setState({ subChapters: subChapters }, () => {
        this.adjustIntAreaNew(area)
      })
    }, 100);

  }

  renderCountryList() {
    const { countryList, tempCountryList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 1 }}
      >
        {tempCountryList.length > 0 &&
          tempCountryList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) => this.callCountryList(data.Description, data.Code)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }

  onCountryBlur(value, index) {
    const { manufactureCountryIndex, SSRCountryList, countryList, subChapters, exhibitDetailsList, area, internationalAreaSlabList } = this.state
    var err = false
    if (SSRCountryList.length > 0) {
      SSRCountryList.map(item2 => {
        if (item2.CountryName.toLowerCase().trim() == value.toLowerCase().trim()) {
          err = true
          subChapters.map((data, i) => {
            if (index == i) {
              data.ManufacturingCountry = ''
              this.setState({
                tempCountryList: countryList,
                isDisplayCountryList: false,
                manufactureCountryIndex: index
              });
            }
          })

          this.setState({
            isOpen2: true
          })
          this.setState({ isDisplayCountryList: false, subChapters: subChapters });
          return
        }
      })
    }

  }

  callCountryList(value, id) {
    const { manufactureCountryIndex, SSRCountryList, countryList, subChapters, area, internationalAreaSlabList } = this.state
    // var err = false
    // if (SSRCountryList.length > 0) {
    //   SSRCountryList.map(item2 => {
    //     if (item2.CountryID == id) {
    //       err = true
    //       subChapters.map((data, i) => {
    //         if (manufactureCountryIndex == i) {
    //           data.ManufacturingCountry = ''
    //           this.setState({
    //             tempCountryList: countryList,
    //             isDisplayCountryList: false,
    //             manufactureCountryIndex: manufactureCountryIndex
    //           });
    //         }
    //       })
    //       this.setState({
    //         isOpen2: true
    //       })
    //       this.setState({ isDisplayCountryList: false, subChapters: subChapters });
    //       return
    //     }
    //   })
    // }
    // if (!err) {
    subChapters.map((data, i) => {
      if (manufactureCountryIndex == i) {
        data.ManufacturingCountry = value
      }
    })
    const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)

    // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
    // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    // var total = 0
    // if (tempTotal == 0) {
    //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
    //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
    //             total = internationalAreaSlabList[i].MinArea
    //         }
    //     }
    // } else {
    //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //     if (totalInternational == 0) {
    //         if ((area - totalNational) > 0) {
    //             total = area - totalNational
    //         } else {
    //             total = 0
    //         }
    //     } else {
    //         if (area >= totalInternational) {
    //             total = totalInternational
    //         } else {
    //             total = 0
    //         }
    //     }
    // }
    // setTimeout(() => {
    //     if (filterArrayBroSome) {
    //         // if (minArea == 0) {
    //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
    //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
    //         //     if ((parseFloat(area) / 2) < totalNational) {
    //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
    //         //     } else {
    //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
    //         //     }
    //         // } else {
    //         this.setState({ InternationalArea: total })
    //         // }
    //         // if (minArea != 0) {
    //         //     this.setState({ InternationalArea: total })
    //         // }
    //     } else {
    //         this.setState({ InternationalArea: 0 })
    //     }
    //     this.setState({ subChapters: subChapters })
    //     this.adjustInternationalArea(area)
    // }, 100);
    setTimeout(() => {
      this.adjustIntAreaNew(area)
    }, 100);
    this.setState({ isDisplayCountryList: false });
    this.getFillList(countryActionId, "", "", "", "", "", "");
    // }
  }

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength);
    }
  };

  // On Back Click
  onCancelClick() {
    window.history.back();
  }

  // On Add click
  onAddClick(e) {
    e.preventDefault();
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  // on check level 2
  onCheckLevel2(e, id) {
    const { level2, subChapters, exbTableErr, area } = this.state;
    var tempExhibitDetailsList = [];
    for (let i = 0; i < level2.length; i++) {
      if (level2[i]["ChapterID"] == id) {
        if (e.target.checked) {
          if (!subChapters.includes(level2[i])) {
            level2[i].isLengthValidate = false;
            subChapters.push(level2[i]);
            this.setState({ subChapters: subChapters });
          }
        } else {
          this.setState({
            subChapters: subChapters.filter((item) => item.ChapterID != level2[i]["ChapterID"]),
          });
        }

        level2[i]["IsSelect"] = !level2[i]["IsSelect"];
      }
    }
    setTimeout(() => {
      this.setState({ level2: level2, exbTableErr: "", InternationalArea: '' });
      setTimeout(() => {
        this.adjustIntAreaNew(area)
      }, 100);
    }, 200);
  }

  // on check level 3
  onCheckLevel3(e, id) {
    const { level3, subChapters, area } = this.state;
    var tempExhibitDetailsList = [];
    for (let i = 0; i < level3.length; i++) {
      if (level3[i]["ChapterID"] == id) {
        if (e.target.checked) {
          if (!subChapters.includes(level3[i])) {
            level3[i].isLengthValidate = false;
            subChapters.push(level3[i]);
            this.setState({ subChapters: subChapters });
          }
        } else {
          this.setState({
            subChapters: subChapters.filter((item) => item.ChapterID != level3[i]["ChapterID"]),
          });
        }

        level3[i]["IsSelect"] = !level3[i]["IsSelect"];
      }
    }
    setTimeout(() => {
      this.setState({ level3: level3, exbTableErr: "", InternationalArea: '' });
      setTimeout(() => {
        this.adjustIntAreaNew(area)
      }, 100);
    }, 200);
  }

  getDoubleStroeySSI() {
    this.setState({ isLoading: true });
    const exhRegistrationID = sessionStorage.getItem("ExhRegistrationIDSS");
    const exhibitionID = sessionStorage.getItem("sessionExhibitionID");

    this.props
      .getDoubleStoreySSI_action(exhRegistrationID, exhibitionID)
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            var guideLines = [];
            for (var i = 0; i < data.data[1].length; i++) {
              if (data.data[1][i].NoteType == "Guidelines") {
                guideLines.push(data.data[1][i]);
              }
            }
            this.setState({
              guideLines: guideLines,
              isShowMachineryGuidelines: data.data[0][0].isShowMachineryGuidelines,
              guidelinesAddress: data.data[0][0].Address,
              DueDate: data.data[0][0].DueDate,
            });
            this.setState({ isLoading: false });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  onMBclick(mode, id, index) {
    const { level4, exhibitDetailsList, subChapters, internationalAreaSlabList, area } = this.state
    console.log("id", id)

    subChapters.map((data, i) => {
      if (data.ChapterID == id) {
        if (mode == 0) {
          if (data.isMachine) {
            data.isMachine = false
          } else {
            data.isMachine = true
          }
        } else if (mode == 1) {
          if (data.isBrochure) {
            data.isBrochure = false
          } else {
            data.isBrochure = true
          }
        } else if (mode == 2) {
          if (data.IsAccessory) {
            data.IsAccessory = false
          } else {
            data.IsAccessory = true
          }
        }
      }
    })
    setTimeout(() => {
      console.log("exhibitDetailsList", subChapters)
      this.setState({ subChapters: subChapters, lengthWidthErr: '' }
        , () => {

          // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
          // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
          // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
          // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          // var total = 0
          // if (tempTotal == 0) {
          //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
          //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
          //             total = internationalAreaSlabList[i].MinArea
          //         }
          //     }
          // } else {
          //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //     if (totalInternational == 0) {
          //         if ((area - totalNational) > 0) {
          //             total = area - totalNational
          //         } else {
          //             total = 0
          //         }
          //     } else {
          //         if (area >= totalInternational) {
          //             total = totalInternational
          //         } else {
          //             total = 0
          //         }
          //     }
          // }
          // setTimeout(() => {
          //     if (filterArrayBroSome) {
          //         // if (minArea == 0) {
          //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
          //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //         //     if ((parseFloat(area) / 2) < totalNational) {
          //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
          //         //     } else {
          //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
          //         //     }
          //         // } else {
          //         this.setState({ InternationalArea: total })
          //         // }
          //         // if (minArea != 0) {
          //         //     this.setState({ InternationalArea: total })
          //         // }
          //     } else {
          //         this.setState({ InternationalArea: 0 })
          //     }
          //     this.setState({ subChapters: subChapters })
          //     this.adjustInternationalArea(area)
          // }, 100);
          setTimeout(() => {
            this.adjustIntAreaNew(area)
          }, 100);
        }
      )

    }, 200);


  }

  onFilePick = async (e, file, i) => {
    e.preventDefault()
    const { subChapters } = this.state
    // console.log("File01010101------", file, key)
    const { } = this.state
    if (file.length != 0) {
      if (file[0]['size'] >= 5 * 1024 * 1024) {
        toastError('File size more than 5mb are not allow.')
      } else {
        var image = '';
        if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
          file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
          file[0]['name'].toString().toLowerCase().includes('.png') ||
          file[0]['name'].toString().toLowerCase().includes('.jpg')
        ) {

          if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
          ) {
            image = await this.resizeFile(file[0]);
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            subChapters[i].DocumentFile = image
            subChapters[i].DocumentName = file[0]['name'].toString()
            //     visitorGroupList[i].passportFileErr = ''
            this.setState({ subChapters: subChapters })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
            // }

          }
          else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
            image = await this.onPdfSelect(file[0]);
            // if (key == 1) {
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            subChapters[i].DocumentFile = image
            subChapters[i].DocumentName = file[0]['name'].toString()
            this.setState({ subChapters: subChapters })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "" })
            // }
            // this.setState({ passportFile: image, passportFileErr: "" })

          }

          var fileType = file[0]['type']
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/")
          }
          // if (sessionStorage.getItem('VisitorTypeID') == 2) {
          //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          //     this.setState({ visitorGroupList: visitorGroupList })
          // } else {
          subChapters[i].DocumentType = fileTypeList.length > 0 ? fileTypeList[1] : ""

          // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
          // }
        } else {
          toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
          document.getElementById(`file${i}`).value = ""

          // if (key == 1) {
          //     this.setState({ passportFile: "" })
          //     document.getElementById("passportFile").value = ""
          // } else if (key == 2) {
          //     this.setState({ visitorLetterFile: "" })
          //     document.getElementById("visitorLetter").value = ""
          // }
        }
      }
    }
  }

  onFilePickBro = async (e, file, typeName) => {
    e.preventDefault();
    const { formFile, trcFile, declarationFile, formFileType, declarationFileType, trcFileType } =
      this.state;
    var image = "";
    if (file[0]["size"] > 3145728) {
      toast.error("File size more than 3MB are not allow.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else {
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        //Convert file to BASE64
        if (file[0]["name"].includes("pdf")) {
          image = await this.onPdfSelect(file[0]);
        } else {
          image = await this.resizeFile(file[0]);
        }

        //Save BASE64 + File Name in React State
        this.setState({
          filePath: image,
          fileName: file[0]["name"],
          brochureErr: "",
          fileIsFromBackend: false,
        });

        const fileType = file[0]["type"];
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/");
        }
        const finalFileTypeName = fileTypeList.length > 0 ? fileTypeList[1] : "";

        this.setState({
          filePath: image,
          fileType: finalFileTypeName,
          brochureErr: "",
          fileIsFromBackend: false,
        });
      } else {
        // Only .pdf , .jpeg, .png, .jpg files are allowed
        toast.error("Only .pdf, .jpeg, .png, files are allowed", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  // File resize
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });

  onCrossClick(i) {
    const { subChapters } = this.state
    // i = i - 1
    // console.log(isPassportFilePresent, i + 1)
    // if (sessionStorage.getItem('VisitorTypeID') == 1) {
    // console.log('isPassportFilePresent', isPassportFilePresent)
    if (subChapters[i].isFilePresent) {
      // const { isOpen3 } = this.state
      // this.setState({ isOpen3: !isOpen3 })
      console.log("condition------------1111111111")
    } else {
      console.log("condition------------2222222222")
      // if (key == 1) {
      // if (mode == 1) {
      //     this.setState({ passportFile: "", isVisaApplied: false })
      // } else {
      subChapters[i].DocumentFile = ""
      this.setState({ subChapters: subChapters })
      document.getElementById(`file${i}`).value = ""
      // }
      // } else if (key == 2) {
      //     this.setState({ visitorLetterFile: "" })
      //     document.getElementById("visitorLetter").value = ""
      // }
    }
  }

  // to call level third list
  record(level2, level3, level4) {
    // var newdata = JSON.stringify(data);
    var tempLevel3 = [];
    for (var j = 0; j < level3.length; j++) {
      if (level2.ChapterID == level3[j]["ParentChapterID"]) {
        tempLevel3.push(level3[j]);
      }
    }
    return (
      <>
        <div
          id={"collapse_l1_" + level2.ChapterID}
          class="accordion-collapse collapse"
          aria-labelledby={"heading_l1_" + level2.ChapterID}
          data-bs-parent="#accordionExample"
        >
          {tempLevel3 &&
            tempLevel3.map((level3data) => {
              return (
                <div class="accordion-body">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id={"heading_l2_" + level3data.ChapterID}>
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse_l2_" + level3data.ChapterID}
                        aria-expanded="false"
                        aria-controls={"collapse_l2_" + level3data.ChapterID}
                      >
                        {/* // checkbox for level3 */}
                        {level3data.IsCheckbox && (
                          <input
                            type="checkbox"
                            // disabled={true}
                            className="from-left-sp"
                            name=""
                            key={level3data.ChapterID}
                            checked={level3data.IsSelect}
                            onClick={(e) => this.onCheckLevel3(e, level3data.ChapterID)}
                          />
                        )}
                        {level3data.ChapterName}{" "}
                      </button>
                    </h2>
                    {this.recordFour(level3data, level4)}
                  </div>
                </div>
              );
            })}
        </div>
      </>
    );
  }

  // on check level 4
  onSelectLevel4(e, id) {
    const { level4, subChapters, area } = this.state;
    var tempExhibitDetailsList = [];
    for (let i = 0; i < level4.length; i++) {
      if (level4[i]["ChapterID"] == id) {
        if (e.target.checked) {
          if (!subChapters.includes(level4[i])) {
            level4[i].isLengthValidate = false;
            subChapters.push(level4[i]);
            this.setState({ subChapters: subChapters });
          }
        } else {
          this.setState({
            subChapters: subChapters.filter((item) => item.ChapterID != level4[i]["ChapterID"]),
          });
        }

        level4[i]["IsSelect"] = !level4[i]["IsSelect"];
      }
    }
    setTimeout(() => {
      console.log("xxxxxxxxxxxxxxxxxxxxxxxxx", subChapters);
      this.setState({ level4: level4, exbTableErr: "", InternationalArea: '' });
      setTimeout(() => {
        this.adjustIntAreaNew(area)
      }, 100);
    }, 200);
  }

  // to call level four list
  recordFour(level3data, level4) {
    var tempLevel4 = [];
    for (var j = 0; j < level4.length; j++) {
      if (level3data.ChapterID == level4[j]["ParentChapterID"]) {
        tempLevel4.push(level4[j]);
      }
    }
    return (
      <>
        <div
          id={"collapse_l2_" + level3data.ChapterID}
          class="accordion-collapse collapse"
          aria-labelledby={"heading_l2_" + level3data.ChapterID}
        >
          {tempLevel4 &&
            tempLevel4.map((level4data) => {
              return (
                <div class="accordion-body third-step">
                  {/* level4data.IsCheckbox && */}
                  <input
                    type="checkbox"
                    // disabled={true}
                    name=""
                    key={level4data.ChapterID}
                    checked={level4data.IsSelect}
                    onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID)}
                  />
                  {level4data.ChapterName}
                </div>
              );
            })}
        </div>
      </>
    );
  }

  // handle typing text area
  handleInputChange = (e) => {
    this.setState({ inputText: e.target.value, textEntriesErr: "" });
  };

  handleAddText = (e) => {
    const { inputText, textEntries } = this.state;

    if (inputText.trim() === "") {
      toastError("Please enter some text");
      return;
    }

    const newEntry = {
      id: Date.now(),
      text: inputText.trim(),
    };

    // add entry, clear input and try to focus the input after render
    this.setState(
      {
        textEntries: [...textEntries, newEntry],
        inputText: "",
        textEntriesErr: "",
      },
      () => {
        console.log("handleAddText: added entry", newEntry);
        // use a small timeout to ensure DOM updated before focusing
        setTimeout(() => {
          try {
            //“Only try to focus the input if: 1 -The input element exists now, 2-It actually supports the focus() function.”
            if (this.keywordInput && this.keywordInput.focus) this.keywordInput.focus();
          } catch (err) {
            console.log("focus error", err);
          }
        }, 50);
      }
    );
  };

  //handleDeleteEntry

  handleDeleteEntry = (id) => {
    this.setState({
      textEntries: this.state.textEntries.filter((entry) => entry.id !== id),
      textEntriesErr:
        this.state.textEntries.filter((entry) => entry.id !== id).length === 1
          ? ""
          : this.state.textEntriesErr,
    });
  };

  //removeBrochureFile

  removeBrochureFile = (e) => {
    e.preventDefault();
    this.setState({
      filePath: "",
      fileName: "",
      fileType: "",
      brochureErr: "",
    });
  };

  adjustIntAreaNew(area, flag) {
    const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
      level2, level3, level4, schemeType, schemeTypeList, countryId, subChapters, oldInternationalArea, referenceStallAreaArr,
      stallAreaId, stallAreaList, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
      openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, compareObjArr } = this.state
    if (area != '' && area != null) {
      var total = 0
      var psuedoList = []
      var isAllBrochure = true
      const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
      if (filterArray.length > 0) {
        for (var i = 0; i < filterArray.length; i++) {
          var tempJSON = {}
          if (filterArray[i].isBrochure) {
            tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
            tempJSON.IsAccessory = false
            tempJSON.isMachine = false
            psuedoList.push(tempJSON)
          }
          if (filterArray[i].IsAccessory) {
            tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
            isAllBrochure = false
            tempJSON.isBrochure = false
            tempJSON.isMachine = false
            psuedoList.push(tempJSON)
          }
          if (filterArray[i].isMachine) {
            tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
            isAllBrochure = false
            tempJSON.IsAccessory = false
            tempJSON.isBrochure = false
            psuedoList.push(tempJSON)
          }
        }
        // for (var i = 0; i < psuedoList.length; i++) {
        var brochureArea = 0
        // if (containsBrochure) {
        for (var i = 0; i < internationalAreaSlabList.length; i++) {
          if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
            brochureArea = internationalAreaSlabList[i].MinArea
          }
        }
        // }
        var accNew = true
        var uniqueManuNameAcc = []
        var uniqueManuNameManuCountry = []
        var uniqueManuNameBro = []
        var uniqueManuNameMachine = []
        if (isAllBrochure) {
          total = brochureArea
          this.setState({ isAllBro: true })
        } else {
          this.setState({ isAllBro: false })
          for (var i = 0; i < psuedoList.length; i++) {
            if (psuedoList[i].isMachine) {
              total = psuedoList[i].Area ? total + psuedoList[i].Area : total
              if (!uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.trim())) {
                uniqueManuNameMachine.push(psuedoList[i].ManufacturerName.trim())
              }
              uniqueManuNameManuCountry.push({ ManufacturerName: psuedoList[i].ManufacturerName.trim(), ManufacturingCountry: psuedoList[i].ManufacturingCountry.trim() })
            }
          }
          console.log('total', total)
          for (var i = 0; i < psuedoList.length; i++) {
            if (psuedoList[i].IsAccessory) {
              if (psuedoList[i].ManufacturerName != null && psuedoList[i].ManufacturerName != '') {
                console.log(uniqueManuNameManuCountry, psuedoList[i].ManufacturerName.trim())
                var isSameAcc = false
                for (var a = 0; a < uniqueManuNameManuCountry.length; a++) {
                  if (uniqueManuNameManuCountry[a].ManufacturerName == psuedoList[i].ManufacturerName.trim() && uniqueManuNameManuCountry[a].ManufacturingCountry == psuedoList[i].ManufacturingCountry.trim()) {
                    isSameAcc = true
                  }
                }
                // if (uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.trim())) {
                //     isSameAcc = true
                // }
                // console.log('uniqueManuNameMachine', uniqueManuNameMachine, psuedoList)
                if (!isSameAcc) {
                  uniqueManuNameManuCountry.push({ ManufacturerName: psuedoList[i].ManufacturerName.trim(), ManufacturingCountry: psuedoList[i].ManufacturingCountry.trim() })
                  total = total + 18
                }
                if (!uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.trim())) {
                  uniqueManuNameAcc.push(psuedoList[i].ManufacturerName.trim())
                }
              }
            }
          }
          console.log('total', total)
          for (var i = 0; i < psuedoList.length; i++) {
            if (psuedoList[i].isBrochure) {
              if (psuedoList[i].ManufacturerName != null && psuedoList[i].ManufacturerName != '') {
                console.log(uniqueManuNameBro, psuedoList[i].ManufacturerName.trim(), '111')
                if (!uniqueManuNameBro.includes(psuedoList[i].ManufacturerName.trim()) && !uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.trim()) && !uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.trim())) {
                  console.log(psuedoList[i].ManufacturerName.trim(), '222')
                  uniqueManuNameBro.push(psuedoList[i].ManufacturerName.trim())
                  total = total + 9
                }
              }
            }
          }
        }
        console.log('000000000000000000000000', uniqueManuNameAcc,
          uniqueManuNameBro,
          uniqueManuNameMachine)
        console.log('total', total)
        // var tempStallArea = JSON.parse(JSON.stringify(stallAreaList))
        // tempStallArea.unshift({ StallArea: 9 })
        var newArea = total
        if (!isAllBrochure) {
          for (var i = 0; i < referenceStallAreaArr.length; i++) {
            if (total <= referenceStallAreaArr[i].StallArea) {
              newArea = referenceStallAreaArr[i].StallArea
              break
            }
          }
        }
        setTimeout(() => {
          if (flag == 1) {
            compareObjArr.push({ name: 'InternationalArea', oldValue: newArea, newValue: newArea, display: 'International Area' })
            this.setState({ compareObjArr: compareObjArr })
          }
          this.setState({
            InternationalArea: newArea, isShowInternationalArea: true, oldInternationalArea: flag == 1 ? newArea : oldInternationalArea,
          }, () => {
            console.log('here 4', 0)
          })
        }, 250);
      } else {
        if (flag == 1) {
          compareObjArr.push({ name: 'InternationalArea', oldValue: total, newValue: total, display: 'International Area' })
          this.setState({ compareObjArr: compareObjArr })
        }
        this.setState({ InternationalArea: 0, isShowInternationalArea: false, oldInternationalArea: flag == 1 ? total : oldInternationalArea }, () => {
          console.log('here 4', 0)
        })
      }
    } else {
      if (flag == 1) {
        compareObjArr.push({ name: 'InternationalArea', oldValue: total, newValue: total, display: 'International Area' })
        this.setState({ compareObjArr: compareObjArr })
      }
      this.setState({ InternationalArea: 0, isShowInternationalArea: false, oldInternationalArea: flag == 1 ? total : oldInternationalArea }, () => {
        console.log('here 4', 0)
      })
    }
    this.setState({ InternationalAreaErr: '', lengthWidthErr: '' })
  }

  onSchemeTypeChange(e, id) {
    const { countryId, subChapters, stallTypeIdList, area, stallArea } = this.state
    console.log('id :', id, stallTypeIdList, subChapters);
    if (e) {
      e.preventDefault();
    }
    var minAreaAsModule = 0
    this.getFillList(lengthActionId, sessionStorage.getItem("sessionExhibitionID"), '', id, countryId, '')
    this.getFillList(breadthActionId, sessionStorage.getItem("sessionExhibitionID"), '', id, countryId, '')
    this.setState({ stallTypeId: id, schemeTypeErr: '', area: '', isDoubleStorey: false, doubleStoreyArea: '', isSSi: false, stallArea: '', stallTypeIdErr: '' })
    for (var i = 0; i < subChapters.length; i++) {
      if (id == 1) {
        if (subChapters[i].MinBareArea != '' && subChapters[i].MinBareArea != null) {
          if (minAreaAsModule < subChapters[i].MinBareArea) {
            minAreaAsModule = subChapters[i].MinBareArea
          }
        }
      } else if (id == 2) {
        if (subChapters[i].MinShellArea != '' && subChapters[i].MinShellArea != null) {
          if (minAreaAsModule < subChapters[i].MinShellArea) {
            minAreaAsModule = subChapters[i].MinShellArea
          }
        }
      }
    }
    this.setState({ isLoading: false })
    this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, id, countryId, '').then(() => {
      this.getFillList(fullStallAreaActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, id, countryId, '').then(() => {
        this.setState({ isLoading: false, InternationalArea: '' }, () => {
          // this.adjustInternationalArea(area)
          setTimeout(() => {
            this.adjustIntAreaNew(area)
          }, 100);
        })
      })
    })
  }

  onLengthTypeChange(e) {

    const { stallAreaList, subChapters, oldarea, isSSi, internationalAreaSlabList } = this.state
    console.log(e.target.value, oldarea)
    var newArea = ''
    for (var i = 0; i < stallAreaList.length; i++) {
      if (stallAreaList[i].Code == e.target.value) {
        newArea = stallAreaList[i].StallArea
      }
    }
    if (newArea < oldarea) {
      this.setState({ isOpen5: true })
    } else {
      this.setState({ stallArea: e.target.value, stallAreaErr: '' })
      console.log(e.target.value)
      for (var i = 0; i < stallAreaList.length; i++) {
        if (stallAreaList[i].Code == e.target.value) {

          // const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
          // console.log('stallAreaList[i].StallArea  : ', stallAreaList[i].StallArea);
          // console.log('totalArea  : ', totalArea);
          // if (stallAreaList[i].StallArea < totalArea) {
          //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
          // } else {
          //     this.setState({ lengthWidthErr: '' })
          // }
          this.setState({ stallAreaName: stallAreaList[i].Description, area: stallAreaList[i].StallArea, lengthWidthErr: '' })

          // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
          // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
          // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
          // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          // var total = 0
          // if (tempTotal == 0) {
          //     for (var j = 0; j < internationalAreaSlabList.length; j++) {
          //         if (internationalAreaSlabList[j].FromRange - 1 < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[j].ToRange) {
          //             total = internationalAreaSlabList[j].MinArea
          //         }
          //     }
          // } else {
          //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //     if (totalInternational == 0) {
          //         if ((stallAreaList[i].StallArea - totalNational) > 0) {
          //             total = stallAreaList[i].StallArea - totalNational
          //         } else {
          //             total = 0
          //         }
          //     } else {
          //         if (stallAreaList[i].StallArea >= totalInternational) {
          //             total = totalInternational
          //         } else {
          //             total = 0
          //         }
          //     }
          // }
          // // setTimeout(() => {
          // if (filterArrayBroSome) {
          //     // if (minArea == 0) {
          //     //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
          //     //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //     //     if ((parseFloat(area) / 2) < totalNational) {
          //     //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
          //     //     } else {
          //     //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
          //     //     }
          //     // } else {
          //     this.setState({ InternationalArea: total })
          //     // }
          //     // if (minArea != 0) {
          //     //     this.setState({ InternationalArea: total })
          //     // }
          // } else {
          //     this.setState({ InternationalArea: 0 })
          // }
          // this.setState({ subChapters: subChapters })
          // this.adjustInternationalArea(stallAreaList[i].StallArea)
          //  setTimeout(() => {
          this.adjustIntAreaNew(stallAreaList[i].StallArea)
          // }, 100);
          // }, 100);


          // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
          // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          // var minArea = 0
          // for (var j = 0; j < internationalAreaSlabList.length; j++) {
          //     if (internationalAreaSlabList[j].FromRange < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[j].ToRange) {
          //         if (total >= internationalAreaSlabList[j].MinArea) {
          //             total = total
          //             minArea = total
          //         } else {
          //             total = internationalAreaSlabList[j].MinArea
          //             minArea = internationalAreaSlabList[j].MinArea
          //         }
          //     }
          // }
          this.setState({
            isDoubleStorey: false,
            doubleStoreyArea: '',
            isSSIandTMMAITAMMMA: '',
            isSSi: false
          })
          // if (filterArray.length > 0) {
          //     // if (minArea == 0) {
          //     //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
          //     //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
          //     //     if ((parseFloat(area) / 2) < totalNational) {
          //     //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
          //     //     } else {
          //     //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
          //     //     }
          //     // } else {
          //     this.setState({ InternationalArea: total })
          //     // }
          //     // if (minArea != 0) {
          //     //     this.setState({ InternationalArea: total })
          //     // }
          // } else {
          //     this.setState({ InternationalArea: 0 })
          // }
          // this.adjustInternationalArea(stallAreaList[i].StallArea)
        }
      }
    }
  }

  changetoExpArea() {
    const { isLoading, newPopCountry, internationalAreaSlabList, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
      level2, level3, isOpen2, level4, schemeType, schemeTypeList, countryId, selectedPrimaryChapterId, selectedPrimaryChapterIdList,
      stallAreaId, stallAreaList, isOpen4,
      expectedArea, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
      openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, area, isOpenConfirmationModal, stallAreaName } = this.state
    console.log(this.state.expectedAreaId, stallAreaList, expectedArea)
    stallAreaList.map(item => {
      if (item.Code == this.state.expectedAreaId) {
        this.setState({ area: expectedArea, stallArea: this.state.expectedAreaId, isOpen4: false, lengthWidthErr: '' })
        toastSuccess(`Stall Area updated to ${expectedArea}`)
      }
    })
    setTimeout(() => {
      this.adjustIntAreaNew(expectedArea)
    }, 200);
  }

  render() {
    const {
      subChapters, expectedArea,
      stallTypeId, isOpen4, isOpen5,
      isLoading, internationalAreaSlabList,
      exbTableErr,
      isOpen, intAreaRulesPop,
      level2,
      level3, isOpen2,
      level4,
      DeadlineDate, enableArea, enableScheme,
      currentDate,
      guideLines,
      isShowMachineryGuidelines,
      guidelinesAddress,
      Remark,
      StatusID,
      regCompany,
      fasciaName,
      otherPersonInchFirst,
      personInchFirst,
      preFixPersonInch,
      isOtherPreFixPersonInch,
      personInchLast,
      regDesignation,
      regCountry,
      primaryChapterName,
      stallTypeIdList,
      InternationalArea,
      InternationalAreaErr,
      exhibitDetailsTableErr,
      stallArea,
      stallAreaList,
      area,
      isChargesforOpenSides,
      ExhibitDetailsNote,
      openSideList,
      openSlides,
      countryId,
      isDoubleStoreyExhibition,
      isDoubleStorey,
      CompanyInformation,
      Is_View,
      textEntries,
      isHideSection, isOpenConfirmationModal, oldInternationalArea
    } = this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    console.log("ppp", oldInternationalArea);
    var showMandatoryMark = false
    const ExhibitionEmail = sessionStorage.getItem('sessionExhibitionEmail') != '' && sessionStorage.getItem('sessionExhibitionEmail') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionEmail')) : []
    const ExhibitionMobileNo = sessionStorage.getItem('sessionExhibitionMobileNo') != '' && sessionStorage.getItem('sessionExhibitionMobileNo') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo')) : []
    var ExhMail = sessionStorage.getItem('sessionExhibitionEmail') != '' && sessionStorage.getItem('sessionExhibitionEmail') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionEmail')) : []
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className="page">
          <div className="page-main">
            <div className={!isHideSection ? "with-dr-container" : ""}>
              <div className=" width-dr-nav">
                {!isHideSection && (
                  <div className="row mt-4">
                    <ExhibitorTopMenu />
                  </div>
                )}
              </div>
              <div className="card-header p-2 mt-5 border mx-3">
                <h3 className="card-title"> Exhibit Details </h3>
                {
                  <span className="text-danger ml-2" style={{ float: "left" }}>
                    {" "}
                    Last Date Of Submission -{" "}
                    {this.props.location?.state?.ActualDeadline
                      ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                      : "-"}
                  </span>
                }
              </div>

              {/* { !isHideSection && <div className="row mt-4">
                <h6 className="mt-2 " style={{ margin: "1rem" }}>
                  Exhibitor Details{" "}
                  <span className="text-danger">
                    {" "}
                    Last Date Of Submission -{" "}
                    {this.props.location?.state?.ActualDeadline
                      ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                      : "-"}
                  </span>
                </h6>
              </div>} */}
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xl-12 p-2">
                    <div className="card rounded-0 mb-0">
                      <div className="card-body p-0">
                        <div className="row mt-2">
                          <div className="col-xl-6">
                            <label htmlFor="validationCustom03">
                              Name of the Company <span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              disabled={true}
                              value={regCompany}
                              onChange={(e) =>
                                this.setState({ regCompany: e.target.value, regCompanyErr: "" })
                              }
                            />
                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{regCompanyErr}</span>} */}
                          </div>
                          <div className="col-xl-6">
                            <label htmlFor="validationCustom03">
                              Fascia Name (Shell Scheme Only)<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              maxLength={"250"}
                              disabled={true}
                              value={fasciaName}
                              onChange={(e) =>
                                this.setState({ fasciaName: e.target.value, fasciaNameErr: "" })
                              }
                            />
                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{fasciaNameErr}</span>} */}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom03">
                              First Name of Person Incharge <span className="text-red">*</span>
                            </label>

                            <div className="input-group">
                              {/* Prefix Dropdown */}
                              <select
                                disabled
                                className=""
                                style={{ maxWidth: "80px" }}
                                value={preFixPersonInch}
                                onChange={(e) =>
                                  this.setState({
                                    preFixPersonInch: e.target.value,
                                    isOtherPreFixPersonInch: e.target.value === "Other",
                                  })
                                }
                              >
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                                <option value="DR">DR</option>
                                <option value="Prof">Prof</option>
                                <option value="Other">Other</option>
                              </select>

                              {/* First Name Input */}
                              <input
                                type="text"
                                disabled
                                className="form-control"
                                id="validationCustom03"
                                value={personInchFirst}
                                maxLength="100"
                                placeholder="First Name"
                                onChange={(e) =>
                                  this.setState({
                                    personInchFirst: e.target.value,
                                    personInchFirstErr: "",
                                  })
                                }
                              />
                            </div>

                            {/* Other Prefix Input */}
                            {isOtherPreFixPersonInch && (
                              <input
                                type="text"
                                disabled
                                className="form-control mt-2"
                                value={otherPersonInchFirst}
                                placeholder="Enter other prefix"
                                onChange={(e) =>
                                  this.setState({ otherPersonInchFirst: e.target.value })
                                }
                              />
                            )}
                          </div>

                          <div className="col-xl-3">
                            <label>
                              Last Name of Person Incharge<span className="text-red">*</span>
                            </label>
                            <input
                              disabled={true}
                              type="text"
                              className="form-control"
                              maxLength={"100"}
                              value={personInchLast}
                            // onChange={(e) => this.setState({ personInchLast: e.target.value, personInchLastErr: "" })}
                            />
                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{personInchLastErr}</span>} */}
                          </div>
                          <div className="col-xl-3">
                            <label htmlFor="validationCustom03">
                              Designation<span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              disabled={true}
                              value={regDesignation}
                            // onChange={(e) => this.setState({ regDesignation: e.target.value, regDesignationErr: "" })}
                            />
                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{regDesignationErr}</span>} */}
                          </div>
                          <div className="col-xl-3">
                            <label htmlFor="validationCustom03">
                              Country<span className="text-red">*</span>
                            </label>
                            <select
                              className="form-control"
                              disabled={true}
                              value={countryId}
                              onChange={(e) => this.setState({ countryId: e.target.value })}
                            >
                              <option>Select Your Country</option>
                              {this.state.countryList.length > 0 &&
                                this.state.countryList.map((item) => (
                                  <option key={item.Code} value={item.Code}>
                                    {item.Description}
                                  </option>
                                ))}
                            </select>
                            {/* {isDisplayCountryList && this.renderCountryList()} */}
                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{regCountryErr}</span>} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-cus card-cus-2 mb-2 cus-width">
                    <p className="p-2 mb-1">
                      Selected Primary Chapter :{" "}
                      <span>
                        <spa>{primaryChapterName}</spa>
                      </span>
                    </p>
                    <div class="card mb-2 mt-0">
                      <div className="card-header cus-hed">
                        Scheme Type <span className="text-danger">*</span>
                      </div>
                      <div className="form-row p-2">
                        {stallTypeIdList.length > 0 &&
                          stallTypeIdList.map((stallTypeIdListData) => (
                            <div className="col-xl-2">
                              <label>
                                <input
                                  type="radio"
                                  id={"stallTypeId"}
                                  name={"stallTypeId"}
                                  disabled={!enableScheme}
                                  radioGroup={stallTypeId == stallTypeIdListData.Code && true}
                                  select={stallTypeId == stallTypeIdListData.Code && true}
                                  checked={stallTypeId == stallTypeIdListData.Code && true}
                                  value={stallTypeId}
                                  onChange={e => this.onSchemeTypeChange(e, stallTypeIdListData.Code)}
                                />
                                {stallTypeIdListData.Description}
                              </label>
                            </div>
                          ))}
                        {/* {<span className='text-danger '>{stallTypeIdErr}</span>} */}
                      </div>
                    </div>
                    <div class="card mb-2">
                      <div className="card-header cus-hed"
                        style={{
                          borderTop: "1px solid #eee",
                        }}
                      >
                        Stall Area <span className="text-danger">*</span>
                      </div>
                      <div className="form-row p-2">
                        <div className="col-xl-3">
                          <label>Length * width in Meters</label>
                          <select
                            className="form-control select2 select-hidden-accessible pl-0"
                            id="roledb"
                            value={stallArea}
                            disabled={!enableArea}

                            onChange={e => this.onLengthTypeChange(e)}
                          >
                            <option value="">Select</option>
                            {stallAreaList.length > 0 &&
                              stallAreaList.map((stallAreaData) => (
                                <option value={stallAreaData.Code} key={stallAreaData.Code}>
                                  {stallAreaData.Description}
                                </option>
                              ))}
                          </select>
                          {/* {<span className='text-danger text-start text-left d-block mt-1'>{stallAreaErr}</span>} */}
                        </div>
                        {stallArea != "" && stallArea != "Select" && (
                          <div className="col-xl-3 text-left">
                            <label className="mt-4"></label>
                            <span>
                              {this.state.area} sqm.
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div class="card mb-2">
                      <div className="card-header cus-hed"
                        style={{
                          borderTop: "1px solid #eee",
                          position: "relative",
                        }}
                      >
                        Open Sides (Please Tick the no required) <span className="text-danger">*</span>
                      </div>
                      <div className="form-row p-2">
                        {this.state.openSideList.length > 0 &&
                          this.state.openSideList.map((item) => (
                            <>
                              {item.OpenSidesID == 4 ? (
                                this.state.area >= this.state.minAreafor4OpenSide ? (
                                  <div className="col-xl-2">
                                    <label>
                                      <input
                                        type="radio"
                                        name="openSlides"
                                        value={openSlides}
                                        checked={openSlides == item.OpenSidesID}
                                        disabled
                                        onClick={(e) =>
                                          this.setState({
                                            openSlides: item.OpenSidesID,
                                            openSlidesErr: "",
                                          })
                                        }
                                      />{" "}
                                      {item.OpenSideName}
                                    </label>
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                <div className="col-xl-2">
                                  <label>
                                    <input
                                      type="radio"
                                      name="openSlides"
                                      value={openSlides}
                                      checked={openSlides == item.OpenSidesID}
                                      disabled
                                      onClick={(e) =>
                                        this.setState({
                                          openSlides: item.OpenSidesID,
                                          openSlidesErr: "",
                                        })
                                      }
                                    />{" "}
                                    {item.OpenSideName}
                                  </label>
                                </div>
                              )}
                            </>
                          ))}

                        {/* <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '1'}
                                                                                    onClick={e => this.setState({ openSlides: '1', openSlidesErr: '' })} /> 1 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '2'}
                                                                                    onClick={e => this.setState({ openSlides: '2', openSlidesErr: '' })}
                                                                                /> 2 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2 mb-3">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '3'}
                                                                                    onClick={e => this.setState({ openSlides: '3', openSlidesErr: '' })} /> 3 Open Side
                                                                            </label>
                                                                        </div> */}
                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{openSlidesErr}</span>} */}
                      </div>
                    </div>
                    {this.state.isDoubleStoreyExhibition && this.state.stallTypeId == 1 && (
                      <>
                        <div class="card mb-2">
                          <div className="card-header cus-hed"
                            style={{
                              borderTop: "1px solid #eee",
                              position: "relative",
                            }}
                          >
                            <div className="d-flex">
                              <input
                                className="toggle-box mt-1"
                                id="identifier-2"
                                type="checkbox"
                                style={{ float: "left" }}
                                checked={this.state.isDoubleStorey}
                                disabled={true}
                              // onClick={(e) => this.onCheckdoubleStorey(e)}
                              />
                              <div>
                                <label htmlFor="identifier-2" style={{ fontSize: 16 }}>
                                  Double storey
                                </label>
                              </div>
                            </div>
                          </div>
                          {this.state.isDoubleStorey && (
                            <div className="form-row p-2">
                              <div className="col-xl-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={true}
                                  maxLength={"10"}
                                  value={this.state.doubleStoreyArea}
                                // onInput={e => this.maxLengthCheck(e, 10)}

                                // onChange={e => this.onChangeDoubleStorey(e)}
                                />
                              </div>
                              {/* {<span className='text-danger text-start text-left d-block mt-1'>{this.state.doubleStoreyAreaErr}</span>} */}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="mt-2 p-0">
                    <div className="col-xl-12 p-0">
                      {!isHideSection && <div className="row">
                        {currentDate > DeadlineDate && (
                          <span className="text-danger">
                            THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                          </span>
                        )}
                      </div>}
                      <div className="mt-1">
                        {/* <button
                          className="byn btn-primary rounded p-1"
                          style={{
                            float: "right",
                            marginBottom: "10px",
                            height: "30px",
                            cursor: "pointer",
                          }}
                          disabled={currentDate > DeadlineDate}
                          onClick={(e) => this.onAddClick(e)}
                        >
                          Add Chapter
                        </button> */}
                        <button className="btn btn-aqua mb-2"
                          // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                          // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : isReceiptGenerated}
                          style={{ float: 'right' }} onClick={e => this.onAddClick(e)}>
                          Add Exhibit

                        </button>
                      </div>
                      <div className="table-responsive mt-3">
                        <table
                          className="table table-bordered"
                          style={{
                            overflow: 'hidden',
                            border: "1px solid #d8d8d8 !important"
                          }}
                        >
                          <thead>
                            <tr>
                              <th>Product</th>
                              <th>Manufacturer Name<span className="text-danger">*</span></th>
                              <th>Manufacturing Country<span className="text-danger">*</span></th>
                              <th>Machine/Brochure/Accessories</th>
                              <th>Machine Details</th>
                              <th>HSN Code</th>
                              <th colspan="4">Machine Dimension (mtr)</th>
                              {/* <th>Length</th>
                                                                                    <th>Breadth</th>
                                                                                    <th>Height</th> */}
                              <th>Floor Capacity (Kgs per sq mtr)</th>
                              <th>Machine Weight (Kg)</th>
                              <th>Upload Certificate of Origin{showMandatoryMark && <span className="text-red">*</span>}</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className="tbody-th-head">Length{showMandatoryMark && <span className="text-red">*</span>}</td>
                              <td className="tbody-th-head">Breadth{showMandatoryMark && <span className="text-red">*</span>}</td>
                              <td className="tbody-th-head" style={{ padding: '2px 25px' }}>Area{showMandatoryMark && <span className="text-red">*</span>}</td>
                              <td className="tbody-th-head">Height{showMandatoryMark && <span className="text-red">*</span>}</td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            {
                              subChapters.length > 0 ? subChapters.map((data, index) => (
                                <tr>
                                  {data.ChapterID != 0 ? (
                                    <td>{data.ChapterName}</td>
                                  ) : (
                                    <td><input
                                      type="text"
                                      className="form-control"
                                      // maxLength={'10'}
                                      value={data.ChapterName}
                                      // onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onEnterProductName(e, index)}
                                    /></td>
                                  )}
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'200'}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                      value={data.ManufacturerName}
                                      // onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onManufacturerNameChange(e, data.ChapterID, index)}
                                    />
                                  </td>
                                  <td>
                                    {/* <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    maxLength={'100'}
                                                                                                    value={data.ManufacturingCountry}
                                                                                                    onChange={e => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                                                /> */}
                                    <input
                                      type="text"
                                      className="form-control"
                                      required=""
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                      value={data.ManufacturingCountry}
                                      // onBlur={(e) => this.onCountryBlur(e.target.value, index)}
                                      onChange={(e) => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                    />
                                    {console.log("this.state.tempCountryList--->", this.state.tempCountryList)}
                                    {this.state.isDisplayCountryList && this.state.manufactureCountryIndex == index && this.renderCountryList()}
                                  </td>
                                  <td style={{ minWidth: '11rem' }}>
                                    <div>
                                      <input
                                        className="toggle-box mt-1"
                                        id="identifier-2"
                                        type="checkbox"
                                        style={{ float: "left" }}
                                        checked={data.isMachine}
                                        // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                        onClick={(e) => this.onMBclick(0, data.ChapterID, index)}
                                      />
                                      Machine
                                    </div>
                                    <div>
                                      <input
                                        className="toggle-box mt-1"
                                        id="identifier-2"
                                        type="checkbox"
                                        style={{ float: "left" }}
                                        // checked={data.isBrochure}
                                        // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                        checked={data.IsAccessory}
                                        onClick={(e) => this.onMBclick(2, data.ChapterID, index)}
                                      />
                                      Accessories/Product
                                    </div>
                                    <div>
                                      <input
                                        className="toggle-box mt-1"
                                        id="identifier-2"
                                        type="checkbox"
                                        style={{ float: "left" }}
                                        checked={data.isBrochure}
                                        // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                        onClick={(e) => this.onMBclick(1, data.ChapterID, index)}
                                      />
                                      Only Brochure
                                    </div>

                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'200'}
                                      value={data.MachineDetails}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                      // onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onMachineDetailsChange(e, data.ChapterID, index)}
                                    />
                                  </td>

                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'10'}
                                      value={data.HSNCode}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                      onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                    />
                                  </td>

                                  <td style={{ width: '', position: 'relative' }}>
                                    {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={0}
                                      disabled={true}
                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    /> : <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={data.Length}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false ? true : !data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                      onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    />}
                                    {/* <select
                                                                                                    className="form-control select-hidden-accessible"
                                                                                                    id="roledb"
                                                                                                    value={data.Length}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">Select</option>
                                                                                                    {lengthList.length > 0 && lengthList.map((item) => (
                                                                                                        <option value={item.Code}>{item.Description}</option>
                                                                                                    ))}
                                                                                                </select> */}
                                  </td>
                                  <td style={{ width: '', position: 'relative' }}>
                                    {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={0}
                                      disabled={true}
                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    /> : <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={data.Breadth}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false ? true : !data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                      onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                    />}
                                    {/* <select
                                                                                                    className="form-control select-hidden-accessible"
                                                                                                    id="roledb"
                                                                                                    value={data.Breadth}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">Select</option>
                                                                                                    {breadthList.length > 0 && breadthList.map((item) => (
                                                                                                        <option value={item.Code}>{item.Description}</option>
                                                                                                    ))}
                                                                                                </select> */}
                                  </td>
                                  <td style={{ width: '', position: 'relative' }}>
                                    {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={0}
                                      disabled={true}
                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    /> : <input
                                      type="text"
                                      className="form-control"
                                      value={data.Area}
                                      disabled
                                    />}
                                  </td>
                                  <td style={{ width: '', position: 'relative' }}>
                                    {data.isMachine && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>}
                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={0}
                                      disabled={true}
                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    /> : <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={data.Height}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false ? true : !data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                      onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onHeightChange(e, data.ChapterID, index)}
                                    />}
                                  </td>
                                  <td>
                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={0}
                                      disabled={true}
                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    /> : <input
                                      type="text"
                                      title=' Note :
                                                                                                    1- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.
                                                                                                    2- If any exhibitor wants to show live machinery, please contact the organizer for special arrangements.'
                                      className="form-control"
                                      maxLength={'9'}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                      value={data.FloorCapacity}
                                      onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onFloorCapacityChange(e, data.ChapterID, index)}
                                    />}
                                  </td>
                                  <td>
                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={0}
                                      disabled={true}
                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                    /> : <input
                                      type="text"
                                      className="form-control"
                                      maxLength={'9'}
                                      value={data.MachineWeight}
                                      // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                      onInput={e => this.maxLengthCheck(e, 10)}
                                      onChange={e => this.onMachineWeightChange(e, data.ChapterID, index)}
                                    />}
                                  </td>
                                  {console.log(data.DocumentPath, data.DocumentName, data.DocumentFile, '00000000000000000000')}
                                  <td style={{ width: '', position: 'relative' }}>
                                    {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                    {(data.isMachine || data.IsAccessory) ? data.DocDeleted == false || data.DocumentName != '' ? <div style={{
                                      border: '1px solid #ccc',
                                      padding: '10px',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      // marginTop: '10px'
                                    }}>
                                      {/* {console.log(this.state.isSSifile)} */}
                                      {data.DocDeleted == false ? <a
                                        href={data.DocumentPath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <span style={{ marginRight: '10px' }}
                                        >{data.DocumentName}</span>
                                      </a> : <span onClick={() => this.renderNewImage(data.DocumentFile, data.DocumentType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                      >{data.DocumentName}</span>}
                                      <i className={`fa fa-times text-danger img-can`}
                                        onClick={(e) => this.onChapterDocDelete(data.ChapterID, index)}
                                      ></i>
                                    </div>
                                      : <div className="upload-options mt-1" style={{ maxWidth: '200px' }}>
                                        <label style={{ display: 'flex' }}>
                                          <input
                                            type="file"
                                            id={`file${index}`}
                                            ref={this.fileInputRef}
                                            name={`file${index}`}
                                            className="image-upload"
                                            // disabled={sessionStorage.getItem('isPaidByAgentRegistration') == 1 && sessionStorage.getItem('isIndirectAccess') == 'false' ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false : (dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false) ? !toKeepOpen : false}
                                            accept=".jpg, .jpeg, .png, .pdf"
                                            onChange={e => this.onFilePick(e, e.target.files, index)}
                                          // disabled={isView}
                                          />
                                          {
                                            data.DocumentFile != "" &&
                                            <i class="fa fa-times text-danger img-can"
                                              onClick={() => this.onCrossClick(index)}
                                            ></i>
                                          }
                                        </label>
                                      </div> : <div className='text-center mt-2'>-</div>}
                                  </td>
                                  <td>  {data.ChapterID == 0 && <button
                                    type="button"
                                    className="btn btn-sm"
                                    onClick={() => {
                                      subChapters.splice(index, 1)
                                      this.setState({ subChapters: subChapters })
                                    }
                                    }
                                  >
                                    <i className="bi bi-trash text-danger" />
                                  </button>}</td>
                                </tr>
                              )) : <tr >
                                <td colSpan={10} className="text-center">Record not available</td></tr>
                            }

                          </tbody>

                        </table>
                      </div>
                      {console.log("subChapters---->", subChapters)}
                      {<span className='text-danger text-start text-left d-block mt-1'>{exhibitDetailsTableErr}</span>}
                      {
                        ((this.state.isShowInternationalArea) && JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() == 'india')
                        // true
                        &&
                        <div className="col-xl-12 mb-1">
                          <label htmlFor="validationCustom03">
                            <strong>International Area<span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>(International Area Calculation Rules, <div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ intAreaRulesPop: true })}
                            >Click here</div> to view)</span>&emsp; </strong>
                          </label>

                          <input
                            style={{ width: '250px' }}
                            type="text"
                            disabled={true}
                            value={InternationalArea}
                            className="form-control"
                            required=""
                            onChange={(e) => this.setState({ InternationalArea: e.target.value.replace(/[^0-9]/g, ''), InternationalAreaErr: '' }, () => {
                              const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
                              const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim())
                              const total = filterArray.reduce((sum, obj) => sum + obj.Area, 0)
                              // console.log("this.state.area", this.state.area)
                              // console.log("totalArea", totalArea)
                              // console.log("e.target.value", e.target.value)
                              // console.log("total", total)
                              const value = e.target.value.replace(/[^0-9]/g, '')
                              // if (this.state.area < totalArea) {
                              //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
                              // } else {
                              //     this.setState({ lengthWidthErr: '' })
                              // }

                              if (value < total || this.state.area < value) {
                                this.setState({ InternationalAreaErr: "International area cannot be less than above sum of international area's and cannot be greater than stall area" })
                              }
                              // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india')
                              // const total = filterArray.reduce((sum, obj) => sum + obj.Area, 0)
                            })}
                          />{<span className='text-danger' style={{ float: 'left' }}>{InternationalAreaErr}</span>}
                        </div>
                      }
                    </div>
                    {/* <br /> */}
                    {ExhibitDetailsNote.length > 0 &&
                      ExhibitDetailsNote.map((data, i) => (
                        <>
                          {!isHideSection && (
                            <div class="mt-2" style={{ textAlign: "left" }}>
                              <strong>Note: </strong>
                              {data.Description}
                            </div>
                          )}
                          {/* <br /> */}
                        </>
                      ))}
                    {/* <br /> */}
                    <div>
                      {/* <p class="mb-3"><strong>Guideline for Machinery Display at Kenyatta International Convention Centre, Nairobi</strong></p>
                                    <p class="mb-3">1.   Display of machinery is allowed only in static mode</p>
                                    <p class="mb-3">2.  Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space. </p>
                                    <p class="mb-3">3.  Floor load capacity: The floor space can hold 3 tons per sqm inside the hall.</p>
                                    <p class="mb-3">4.  Compressed Air and water supply are not available in the halls.</p>
                                    <p class="mb-3">5.  Loading door dimensions: The length is 9.56 mtr and height is 3.18 mtr.</p>
                                    <p class="mb-3"><strong>Note:</strong> <span class="text-danger"> If  any exhibitor wants to show live machinery, please contact the organizer for special arrangements.</span></p> */}

                      {isShowMachineryGuidelines ? (
                        <p className="m-0 mt-2">
                          <strong>Guideline for Machinery Display at {guidelinesAddress}</strong>
                          <br />
                          {this.state.guideLines.length > 0 &&
                            this.state.guideLines.map((data, i) => (
                              <>
                                {i + 1}- {data.Description}
                                <br />
                              </>
                            ))}
                        </p>
                      ) : (
                        <></>
                      )}

                      {false && (
                        <>
                          <div class="row mt-3">
                            <form>
                              <label>
                                Company Information <span style={{ color: "red" }}>*</span>
                              </label>
                              <textarea
                                class="form-control"
                                value={this.state.CompanyInformation}
                                disabled={Is_View || isDeadlinePassed}
                                onChange={(e) =>
                                  this.setState({
                                    CompanyInformation: e.target.value,
                                    CompanyInformationErr: "", // Clear error on change
                                  })
                                }
                                maxLength={500}
                                rows="3"
                              ></textarea>
                              {this.state.CompanyInformationErr && (
                                <div className="text-danger small mt-1">
                                  <i className="fa fa-exclamation-circle"></i>{" "}
                                  {this.state.CompanyInformationErr}
                                </div>
                              )}
                            </form>
                          </div>

                          <div class="row mt-2">
                            <div class="col-md-3">
                              <label>
                                Brochure Document <span style={{ color: "red" }}>*</span>
                              </label>
                              {this.state.fileName && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "8px 14px",
                                    marginBottom: "10px",
                                    borderRadius: "20px",
                                    backgroundColor: "#f0f0f0",
                                    fontSize: "14px",
                                    marginTop: "10px",
                                    width: "fit-content",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#007bff",
                                      marginRight: "12px",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => this.openBrochure()}
                                  >
                                    {this.state.fileName}
                                  </span>

                                  <button
                                    type="button"
                                    onClick={this.removeBrochureFile}
                                    style={{
                                      background: "none",
                                      border: "none",
                                      color: "#d32f2f",
                                      cursor: "pointer",
                                      fontSize: "10px",
                                      fontWeight: "bold",
                                      lineHeight: "1",
                                    }}
                                  >
                                    ✕
                                  </button>
                                </div>
                              )}

                              {!this.state.fileName && (
                                <input
                                  type="file"
                                  disabled={Is_View}
                                  className="form-control mt-2 mb-2 custom-file-input"
                                  onChange={(e) => {
                                    this.onFilePickBro(e, e.target.files);
                                    this.setState({ brochureErr: "" }); // Clear error on file select
                                  }}
                                  style={{ width: "80%", padding: "0.375rem 0.75rem", height: "calc(1.5em + 0.75rem + 2px)" }}
                                />
                              )}
                              <span
                                className="text-danger"
                                style={{
                                  fontSize: "12px",
                                  display: "block",
                                  paddingRight: "3.5rem",
                                }}
                              >
                                Max 3MB | Pdf,Jpeg,Jpg,Png only
                              </span>
                              {this.state.brochureErr && (
                                <div
                                  className="text-danger small mt-1"
                                  style={{ paddingRight: "42px" }}
                                >
                                  <i className="fa fa-exclamation-circle"></i>{" "}
                                  {this.state.brochureErr}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* sss */}
                          {/* Technical & Marketing Keyword */}
                          <div>
                            <div class="row mt-2">
                              <div class="col-md-3" style={{ width: "100%" }}>
                                <label>
                                  Technical & Marketing Keyword{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>

                                <div
                                  style={{ display: "flex", flexDirection: "column" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      alignItems: "center",
                                      width: "50%",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control mt-2 p-1 mb-2 custom-file-input"
                                      placeholder="Enter Technical & Marketing keyword"
                                      value={this.state.inputText}
                                      // disabled={Is_View || isDeadlinePassed}
                                      onChange={(e) => {
                                        this.handleInputChange(e);
                                        this.setState({ textEntriesErr: "" }); // Clear error on change
                                      }}
                                      ref={(el) => (this.keywordInput = el)}
                                      style={{ marginTop: 0, marginBottom: 0 }}
                                    />
                                    <button
                                      type="button"
                                      onClick={this.handleAddText}
                                      // disabled={Is_View}
                                      className="btn btn-aqua d-block"
                                      style={{
                                        height: "28px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "0 12px",
                                      }}
                                    >
                                      Add
                                    </button>
                                  </div>

                                  {/* Error message for keywords */}
                                  {this.state.textEntriesErr && (
                                    <div className="text-danger small">
                                      <i className="fa fa-exclamation-circle"></i>{" "}
                                      {this.state.textEntriesErr}
                                    </div>
                                  )}

                                  {/* display area */}
                                  <div>
                                    {textEntries.length === 0 ? (
                                      // <p className="text-secondary mb-0">No Keyword added yet</p>
                                      <p className="text-secondary mb-0"></p>
                                    ) : (
                                      <ul
                                        style={{
                                          listStyle: "none",
                                          padding: 0,
                                          margin: 0,
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "10px",
                                          width: "100%",
                                        }}
                                      >
                                        {textEntries.map((entry) => (
                                          <li
                                            key={entry.id}
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              padding: "12px 16px",
                                              border: "1px solid #e3e3e3",
                                              marginBottom: "10px",
                                              borderRadius: "10px",
                                              backgroundColor: "#ffffff",
                                              boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
                                              fontSize: "13px",
                                              height: "1.5rem",
                                              width: "fit-content",
                                              maxWidth: "100%",
                                              // whiteSpace:"nowrap"
                                            }}
                                          >
                                            <span
                                              style={{ flex: 1, color: "#333", fontWeight: 500 }}
                                            >
                                              {entry.text}
                                            </span>

                                            <button
                                              type="button"
                                              onClick={() => this.handleDeleteEntry(entry.id)}
                                              disabled={Is_View}
                                              style={{
                                                background: "none",
                                                border: "none",
                                                color: "#d32f2f",
                                                cursor: "pointer",
                                                fontSize: "10px",
                                                fontWeight: "bold",
                                                lineHeight: "1",
                                                marginLeft: "8px",
                                              }}
                                            >
                                              ✕
                                            </button>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </>
                      )}
                      <div class="row my-2">
                        <form>
                          <label>
                            Remark
                          </label>
                          <textarea
                            class="form-control"
                            value={this.state.Remark}
                            disabled={isDeadlinePassed || Is_View}
                            onChange={(e) =>
                              // isDeadlinePassed &&
                              this.setState({
                                Remark: e.target.value,
                                RemarkErr: "", // Clear error on change
                              })
                            }
                            maxLength={300}
                            rows="3"
                          ></textarea>
                          {this.state.RemarkErr && (
                            <div className="text-danger small mt-1">
                              <i className="fa fa-exclamation-circle"></i>{" "}
                              {this.state.RemarkErr}
                            </div>
                          )}
                        </form>
                      </div>

                      <div className="d-flex justify-content-end mt-0">
                        <button
                          type="button"
                          className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                          style={{ marginRight: 10 }}
                          // disabled={currentDate > DeadlineDate}
                          // onClick={() => this.updateExhibitorDetails()}
                          onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                        >
                          {this.state.StatusID == 0 ? "Submit" : "Update"}
                        </button>

                        <button
                          type="button"
                          className="btn rounded-1 mt-3 mb-3 btn-gray"
                          style={{ marginRight: 10 }}
                          onClick={() => this.onCancelClick()}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div class="footer-sec">
          <div class="sdsd">
              <strong>Ownership:</strong> All content, formats and images used on this site are owned or licensed by India ITME Society. You may not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit, or in any other way exploit any part of copyrighted material without permission of the copyright owner. Failure to comply shall result in legal action.
          </div>
      </div>

      <div class="footer-first">
          <div class="container-fluid">
              <div class="footer-first">  ITME All Rights Reserved <i class="fa fa-copyright" aria-hidden="true"></i> 2023  </div>
          </div>
      </div> */}
          </div>
        </div>
        <Modal isOpen={isOpen} onRequestClose={this.onAddClick}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h6 className="modal-title">Select Below Product
                </h6>
                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"
                  onClick={e => this.setState({ isOpen: !isOpen })}
                />
              </div>
              <div className="modal-body" style={{ maxHeight: '400px', overflow: 'auto' }}>
                <div className="" style={{ paddingLeft: 10 }}>
                  <form className="needs-validation pb-2" noValidate="">
                    <div className="form-row">

                      <div class="accordion" id="accordionExample">
                        {
                          level2.length > 0 && level2.map(level2Data => (
                            <>
                              {
                                // level2Data.ParentChapterID == primaryChapterRadio &&
                                <div class="accordion-item">
                                  <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                    <button class={"accordion-button collapsed"}
                                      type="button" data-bs-toggle="collapse"
                                      data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                      aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                      {/* // checkbox for level2 */}
                                      {
                                        level2Data.IsCheckbox &&
                                        <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                          checked={level2Data.IsSelect}
                                          onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                      }
                                      {level2Data.ChapterName} </button>
                                  </h2>
                                  {this.record(level2Data, level3, level4)}
                                </div>
                              }

                            </>
                          ))
                        }
                      </div>

                    </div>
                  </form>
                </div>
              </div>
              {/* <div className="modal-footer p-1">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            data-bs-dismiss="modal"
                                            style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                                        >
                                            Continue
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            data-bs-dismiss="modal"
                                            style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                                            onClick={e => this.setState({ isOpen: !isOpen })}
                                        >
                                            Back
                                        </button>
                                    </div> */}
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.estimatePop}
          onRequestClose={() => this.setState({ estimatePop: false })}
        >
          <div
            className="modal-dialog modal-fullscreen"
            style={{ margin: 0, width: "95vw", height: "95vh" }}
          >
            <div
              className="modal-content"
              style={{ height: "100%", borderRadius: 0 }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{ padding: "10px 15px" }}
              >
                <h5 className="modal-title">
                  This will be the Revised estimates if you choose to Continue to update
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.setState({ estimatePop: false })}
                />
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: "10px",
                  overflowY: "auto",
                  height: "calc(100vh - 120px)"
                }}
              >
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <tbody>
                      {this.state.newestimateDetails.length > 0 ? (
                        this.state.newestimateDetails.map((data, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                whiteSpace: data.Description.includes("\n")
                                  ? "pre-line"
                                  : "normal"
                              }}
                            >
                              <strong>{data.Description}</strong>
                            </td>

                            <td style={{ textAlign: index !== 0 ? "right" : "center" }}>
                              {index === 0 ? (
                                <strong>{data.Installment1}</strong>
                              ) : (
                                data.Installment1
                              )}
                            </td>

                            <td style={{ textAlign: index !== 0 ? "right" : "center" }}>
                              {index === 0 ? (
                                <strong>{data.Installment2}</strong>
                              ) : (
                                data.Installment2
                              )}
                            </td>

                            <td style={{ textAlign: index !== 0 ? "right" : "center" }}>
                              {index === 0 ? (
                                <strong>{data.OpenSide}</strong>
                              ) : (
                                data.OpenSide
                              )}
                            </td>

                            <td style={{ textAlign: index !== 0 ? "right" : "center" }}>
                              {index === 0 ? (
                                <strong>{data.Total_amt}</strong>
                              ) : (
                                data.Total_amt
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} style={{ textAlign: "center" }}>
                            Record not found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{ padding: "10px", justifyContent: "flex-end" }}
              >
                <button
                  type="button"
                  className="btn btn-aqua"
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    this.setState({ isUpdatePerm: true }, () =>
                      this.updateExhibitorDetails()
                    )
                  }
                >
                  Update
                </button>

                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={() => this.setState({ estimatePop: false })}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <Modal isOpen={isOpen4} onRequestClose={(e) => this.setState({ isOpen4: false })}>
          <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
            <div className="modal-content responsive-width w-auto">
              <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                <div className="modal-body p-2">
                  {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                                             Increase Stall Area
                                                         </p> */}
                  <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                    {this.state.areaValidationPopFlag == 1 ? `The sum of Machine dimension, Accessories and international area cannot be greater than the above selected stall area. Kindly increase your stall area to ${expectedArea} or greater.` : this.state.areaValidationPopFlag == 2 ? `The sum of exhibit item cannot be greater than the above selected stall area. Kindly increase your stall area to ${expectedArea} or greater.` : `National Area must be more than or equal to ${stallTypeId == 1 ? '27sqm' : '18sqm'} for ${stallTypeId == 1 ? 'Bare space scheme type' : 'Shell space scheme type'}.Kindly increase your stall area to ${expectedArea} or greater.`}
                  </p>
                </div>
                <div className="modal-footer pb-1 justify-content-center">
                  <button
                    className="btn mb-1 text-center"
                    type="submit"
                    style={{
                      width: "20%",
                      // display: "block",
                      background: "#007bff",
                      padding: 4
                    }}
                    // onClick={() => this.setState({ isOpen4: false })}
                    onClick={() => this.changetoExpArea()}

                  >
                    {" "}
                    {/* <a
                                                                 className="text-center btn-next text-white"
                                                                 style={{ color: 'white' }}
                                                             > */}
                    OK
                    {/* </a>{" "} */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal >
        <Modal isOpen={isOpen5} onRequestClose={(e) => this.setState({ isOpen5: false })}>
          <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
            <div className="modal-content responsive-width w-auto">
              <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                <div className="modal-body p-2">
                  {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                                             Increase Stall Area
                                                         </p> */}
                  <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                    Your allocated area is {this.state.oldarea} sqm. The deadline to reduce the area has passed, so changes are no longer allowed. Kindly email the Exhibition Team at {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (<a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>)) : null} for assistance.
                  </p>
                </div>
                <div className="modal-footer pb-1 justify-content-center">
                  <button
                    className="btn mb-1 text-center"
                    type="submit"
                    style={{
                      width: "20%",
                      // display: "block",
                      background: "#007bff",
                      padding: 4
                    }}
                    onClick={() => this.setState({ isOpen5: false })}
                  // onClick={() => this.changetoExpArea()}

                  >
                    {" "}
                    {/* <a
                                                                 className="text-center btn-next text-white"
                                                                 style={{ color: 'white' }}
                                                             > */}
                    OK
                    {/* </a>{" "} */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal >
        <Modal isOpen={intAreaRulesPop} onRequestClose={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })} >
          <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
            <div className="modal-content responsive-width w-auto">
              <div className="modal-header" style={{ padding: "10px 10px" }}>
                <h5 className="modal-title" id="termsandconLabel">
                  <b>International Area Calculation Rules</b>
                </h5>
                <button style={{ fontSize: '16px' }}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                />
              </div>

              <div className="modal-body" style={{ overflowY: 'auto' }}>
                <div >
                  <ol>
                    <li><p>
                      If only Brochure is selected for all exhibit items, the international area will be calculated based on the brochure slab.
                      (<div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                      >Click here</div> to view slab.)
                    </p></li>
                    <li><p>
                      If only Brochure is selected along with a combination of Machine or Accessories from different manufacturers, the applicable international area for each brochure will be 9 sqm per manufacturer.
                    </p></li>
                    <li><p>
                      If Machine is selected, the international area will be calculated based on the dimensions specified for each exhibit item.
                    </p></li>
                    <li><p>
                      If Accessories are selected then  the international area will be 18 sqm for each.
                    </p></li>
                    <li><p>
                      If there is a combination of Machine, Accessories, and Brochure, the international area will be calculated as per the respective rules mentioned in Points 2, 3, and 4.
                    </p></li>
                  </ol>
                  <br></br>
                  <p>
                    For any further queries or clarification, please contact the exhibition team at {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>{data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}</>)) : null} or  {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (<a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>)) : null}
                  </p>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button type="button" class="btn btn-aqua" data-dismiss="modal" style={{ marginLeft: '5px' }}
                    onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                  >OK</button>
                </div>
              </div>
              {/* <div className="modal-footer" style={{ padding: 3 }}>
                                                            
                                                                                        </div> */}
            </div>
          </div >

        </Modal >
        <Modal isOpen={this.state.slabpop} >
          <div className="modal-dialog modal-xl" style={{ width: 'fit-content', top: '15%' }}>
            <div className="modal-content responsive-width w-auto" style={{ marginTop: '70px' }}>
              <div className="modal-header" style={{ padding: "16px 20px", fontSize: 'medium', backgroundColor: 'white' }}>
                <div className="mb-0 pt-2 text-center fw-bold w-100">
                  Below listed foreign area Slab applies only to companies that are showcasing foreign companies’ brochures under the booth of an Indian Company or an Indian Agent Company.
                </div>
                {/* <strong> */}
                {/* </strong> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={(e) => this.setState({ slabpop: false, intAreaRulesPop: true })}
                  // style={{ scale: '' }}
                  aria-label="Close"
                >
                  {/* <i class="fa fa-circle-xmark"></i> */}
                </button>
              </div>

              <div className="modal-body pt-0 p-3" style={{ padding: "0px 12px 9px 12px" }}>
                <div className="form-row mt-2" style={{ height: 'calc(100vh - 288px)', overflow: 'auto' }}>
                  <table
                    className="table table-bordered"
                    style={{
                      border: "1px solid #d8d8d8 !important",
                      marginRight: '50px',
                      marginLeft: '50px',
                    }}
                  >
                    <thead>
                      <tr>
                        <th className='text-center'>Area Slab(SQM)</th>
                        <th className='text-center'>USD Tariff to charge</th>
                      </tr>
                    </thead>
                    <tbody>
                      {internationalAreaSlabList.length > 0 && internationalAreaSlabList.map((item, i) => (
                        <tr>
                          <td className='text-center'>{i == internationalAreaSlabList.length - 1 ? `${item.FromRange} sqm and above` : `${item.FromRange} sqm to ${item.ToRange} sqm`}</td>
                          <td className='text-center'>{item.MinArea} sqm</td>
                        </tr>
                      ))}

                    </tbody>
                  </table>


                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={e => this.setState({
                    slabpop: false, intAreaRulesPop: true
                  })}>Back</button>
                </div>
              </div>

            </div>

          </div>
        </Modal>
        <Modal isOpen={isOpen2} onRequestClose={(e) => this.setState({ isOpen2: false })}>
          <div
            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-md" style={{ maxWidth: '660px', marginTop: '1rem', marginLeft: '-9.5rem' }}>
              <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                <div className="modal-body p-2">
                  <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                    Kindly contact your country’s space selling representative to process space booking application.
                  </p>
                  <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                    <strong>
                      <a className='text-primary' href={sessionStorage.getItem('SSRLink')} >Click here to view Space Selling Representative</a>
                    </strong>
                  </p>
                </div>
                <div className="modal-footer pb-1 justify-content-center">
                  <button
                    className="btn mb-1 text-center"
                    type="submit"
                    style={{
                      width: "20%",
                      // display: "block",
                      background: "#007bff",
                      padding: 4
                    }}
                    onClick={() => this.setState({ isOpen2: false })}
                  >
                    {" "}
                    <a
                      className="text-center btn-next text-white"
                      style={{ color: 'white' }}
                    >
                      OK
                    </a>{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal >
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getExhibitorDetails_action,
    updateSpacebookingEstimate_action,
    updateExhibitorDetails_action,
    getDoubleStoreySSI_action,
    fill_action, getExhibitionSSRCountryMappingData_action
  })(ExhibitorDetails)
);
